/* ============================================================
   RYZE PROMO (Part7)  -  assets/ryze-promo.js

   The state engine behind sections/ryze-promo.liquid. It owns four
   surfaces, all of them server rendered by Liquid: the empty-cart
   GREETING (two stacked cards), the PAIR card, the BUNDLE card, the
   HUNDRED card, and the passive PILL. It also owns THE MENU, the
   shared five-row fragrance picker that every card's CTA morphs into.

   THE MENU SELLS BOTH SIZES out of one card. The three pair cards
   open it on the 50 ml list; the two 100 ml cards, the greeting's
   and the `hundred` message's, open the same card on the 100 ml
   list. Which one shows is data-menu-size on
   the host, written from the value on the CTA that was pressed, and
   it is the ONLY thing that differs: same rows, same steppers, same
   hardened add, same success morph, same everything below.

   WHAT THIS FILE IS ALLOWED TO DO
   Flip attributes, flip classes, write textContent, flip the hidden
   attribute, and promote data-src / data-srcset onto media that
   shipped with none. Nothing else. No innerHTML, no createElement,
   no node ever moved. Two whole-document.body MutationObservers
   already run on every page of this store (ryze-quick-add-card.js,
   ryze-wishlist.js); markup built at runtime would feed both of them
   on every showing, and every string would stop being editable in
   the theme editor.

   ES5 ONLY. var, no arrow functions, no template literals, no
   const/let, ['catch'] bracket access. The file is minified by
   Shopify on upload, so it is verified by behaviour, never by
   reading the served asset.

   NO PRICE MATH, ANYWHERE. Not a figure is read, computed, stored or
   transmitted here. /cart/add.js is sent a numeric variant id Liquid
   rendered and an integer quantity the stepper produced. Every LE
   figure a customer sees is either Liquid's `| money` or owner copy
   in a schema setting. There is deliberately no data-price attribute
   in the DOM contract for this component.

   ------------------------------------------------------------
   THE PARTITION (architecture contract 2)

     empty                        -> greet
     qty50 == 1                   -> pair
     qty50 == 0 && has100         -> bundle
     qty50 >= 2 && !has100        -> hundred
     everything else              -> nothing

   Disjoint by arithmetic. qty50 alone separates three of the four:
   empty implies qty50 == 0 AND !has100, pair needs qty50 == 1,
   bundle needs qty50 == 0 and hundred needs qty50 >= 2, so no two
   of pair, bundle and hundred can hold at once and empty holds with
   neither of the has100 branches. greet and bundle are separated a
   second time by has100, and bundle and hundred a second time by it
   as well. The only state left is qty50 >= 2 && has100, which arms
   NOTHING: both promotions are satisfied and there is nothing left
   to pitch. NO CART STATE CAN ARM TWO BOXES.

   hundred is the state the owner's field test found silent: two
   50 ml added through the bundle builder, no 100 ml, nothing shown.
   The pair price is already secured there, so the pair cards have
   nothing to say and the 100 ml offer is the only one still open.

   The PILL is not part of the partition. It is transition scoped:
   it rises on the !has100 -> has100 step and nowhere else, so a tab
   that never observed that step never shows it. It may coexist in
   TIME with the bundle card (the customer just bought a 100 ml and
   owns no 50 ml) but never on screen at once: the pill goes first,
   the card follows bundle_delay after the pill settles.

   ------------------------------------------------------------
   FREQUENCY (owner rulings 2026-07-31, AMENDED 2026-08-19 by
   THE POPUP PRESSURE PROPOSAL, TIER B = tiers 0 + 1)

   The old system was retired because it could be silenced for a
   whole session by a rule nobody could see. That is still banned:
   there is NO seen map and NO shared cooldown between messages, and
   one message's dismissal never silences another.

   What the owner blessed on 2026-08-19 is narrower and named:

     (i)  A DISMISSAL IS RESPECTED. An X is a sentence, not a
          five-minute pause that the customer's very next cart edit
          erases. That message rests for dismiss_minutes (default
          60, the proposal's "session or 60 min") and a cart change
          no longer wipes it. Every OTHER message is untouched, so a
          customer who dismissed the pair card still meets the
          hundred card when the cart earns it.
     (ii) SUPPORT SURFACES ARE QUIET ROOMS. /pages/tracking and
          /pages/returns open no marketing overlay at all. A
          customer chasing a parcel is not shopping in that moment.
          The pill still rises there: it confirms, it does not sell.

   What exists now, in full:

     X on a card       quiets THAT message for dismiss_minutes
                       (default 60) on this device, and a cart
                       change does NOT clear it. On the greeting an
                       X on ONE card promotes the other instead of
                       closing; only Escape closes outright.
     Escape            THE HARD CLOSE (owner call 2026-08-20, a11y):
                       the FIRST Escape closes the whole layer, even
                       when both greeting cards are alive. It stamps
                       the same kind 1 as an X, on the message of the
                       card actually shown (escapeKey() picks it),
                       and it never promotes: the partner is left
                       unsentenced and whole for a later trigger.
                       Escape is the X's twin in KIND, not in
                       choreography - one press always gets out.
     a tap on the      PROMOTES that card to the front (owner order
     peeking card      2026-08-20). It is not a dismissal and not a
                       close: nothing is stamped, the greeting stays
                       up, and the card it displaces takes the peek
                       pose instead of leaving. ONE mechanism, two
                       dispositions - see promoteGreet().
     a backdrop tap    quiets THAT message too, but as a MACHINE
                       quiet: short life, lifted by the very next
                       cart change. A scrim tap is not a sentence
                       (R7, round 13) - only the X and Escape earn
                       the hour.
     the CTA that says  quiets the message as a MACHINE quiet as
     yes (onTargetClick) well: an accept changes the cart state
                       that armed the message in the first place, so
                       the discriminator retires it on its own and
                       the long life would only outlive a state that
                       is already gone.
     any cart change   clears every NON-dismissal quiet (the 100 ml
                       breather, a backdrop tap, an accepted CTA),
                       instantly.
     a new day         clears all quiets, dismissals included.
     the cart page     runs the same rules as everywhere else. Its
                       old ignore-the-quiet grace show is RETIRED
                       (proposal 1b), and nothing may reveal within
                       CART_REACH_MS of the load: that window belongs
                       to the thumb already travelling to Checkout.
     the greeting      shows once per tab visit, and re-arms when
                       the cart transitions back to empty, in any
                       new tab, and on a new calendar day.
     a recent touch    holds any reveal for TOUCH_HOLD_MS (THE
                       COURTESY HOLD): a tap in flight may not be
                       stolen by a layer arriving under it.
     the reveal itself SWALLOWS every tap for ARM_MS (THE
                       CLICKABILITY DELAY, Baymard/AdMob, revised by
                       owner order 2026-08-20). The layer takes
                       pointer events from frame one, so no tap
                       reaches the page underneath it, and the
                       handler refuses to ACT on anything but the
                       close X until is-armed lands. An in-flight tap
                       therefore buys nothing, dismisses nothing and
                       stamps nothing: it dies in the overlay.

   Storage is CHOREOGRAPHY ONLY and never truth. The cart is truth,
   and every decision re-reads /cart.js.

     localStorage  ryze_promo_v1   { q:{greet,pair,bundle,hundred}, k:{…}, s:{q50,h100,n,t}, d:'YYYY-MM-DD' }
     sessionStorage ryze_promo_tab { g: 1 }

   k IS THE QUIET'S KIND, one flag per quiet slot: 1 means a real
   dismissal (long life, survives a cart change), 0 means a machine
   quiet (short life, cleared by a cart change). Only the close X and
   Escape write kind 1 - a deliberate dismissal. (They share the kind;
   they no longer share the choreography, see THE HARD CLOSE above.)
   Everything else that spends a quiet writes kind 0: the 100 ml
   breather, a backdrop tap (not a sentence), and the accept path
   (onTargetClick - the cart change the customer just made retires
   the message on its own, so a long life would be wasted on a state
   that no longer exists). A state written by an older build carries
   no k at all, and a missing k reads as 0 — every legacy quiet
   therefore behaves exactly as it did before this change and
   expires on its own. No migration step and nothing to run once.

   s.n is the whole cart's item_count. It is in the snapshot because
   q50 and h100 between them cannot see a cart that held only other
   products: without n, a bag of samples emptying moves neither
   number, so the greeting would not re-arm and the quiets would not
   clear on a change the customer plainly made. A snapshot stored
   before n existed is read as STALE, never migrated.

   sessionStorage is PER TAB, so it can only ever hold a per-tab
   fact. The quiets and the cart snapshot are cross-tab facts and
   live in localStorage. Both go through one guarded helper with an
   in-memory mirror: Safari private mode throws on the storage
   object itself, and the failure direction here is MORE popups,
   never a crash.

   THE MIRROR OUTRANKS A STORE THAT WOULD NOT TAKE A WRITE. The
   symmetric failure (nothing works) is the easy one. The asymmetric
   one is a full origin, where getItem keeps returning last visit's
   entry while setItem throws: reading that back would undo the
   quiet a customer just spent, every time, forever. So once a write
   has failed the mirror is the whole truth until a later write
   lands. A parse failure is NOT a storage failure and never sets
   that flag: a corrupt value says nothing about the store, and the
   next write repairs it.

   ------------------------------------------------------------
   DELIVERY (architecture 3)

   Four triggers, because several add paths on this store publish
   nothing at all (bundle builder, cart cross-sell, wishlist,
   buy-now):

     1  Dawn pubsub cartUpdate, typeof guarded on both globals
     2  the ryze:cart:updated document event
     3  a MutationObserver on .ryze-nav__cart-count, the one signal
        every add path eventually reaches (ryze-wishlist.js patches
        window.fetch sitewide and rewrites that badge ~300 ms after
        any cart mutation)
     4  the page-load pass, plus pageshow(persisted) for bfcache and
        visibilitychange -> visible for a tab restored after idle

   All four funnel into ONE debounced evaluate() that re-reads
   /cart.js. NO TRIGGER PAYLOAD IS EVER TRUSTED: one publisher on
   this theme sends {} (ryze-sticky-atc.js), which makes a
   subscriber write 0 into the badge and hide it, so both the payload
   and the badge text are unreliable by construction.

   DEBOUNCE_MS IS 400, NOT 250. Two independent races need
   swallowing: that empty publish landing right behind the real one,
   and the sitewide fetch shim firing its own /cart.js read about
   300 ms after every mutation. 400 ms was the value that held.

   ------------------------------------------------------------
   FAIL OPEN

   The whole engine sits inside a guarded bootstrap. Any throw from
   any entry point hides every promo surface and stops the engine for
   that page: the site then behaves exactly as if this component did
   not exist. Nothing here intercepts, wraps or attaches to the
   checkout button or the #cart form. That intercept existed in the
   archived system and is deliberately NOT rebuilt.

   Zero console output on any path a customer can reach.

   QA:  window.RyzePromo = { version, state(), evaluate(), reset() }
   ============================================================ */

(function () {
  'use strict';

  if (window.__ryzePromoInit) return;
  window.__ryzePromoInit = true;

  var VERSION = '7.2.2';

  var STATE_KEY = 'ryze_promo_v1'; /* localStorage, cross tab */
  var TAB_KEY = 'ryze_promo_tab'; /* sessionStorage, THIS tab only */

  /* Timing. Every one of these is a mechanism constant. Anything the
     owner may tune lives on the host as a data attribute and is read
     live on each decision, so a theme-editor edit applies without a
     reload. No knob is baked in here. */
  var DEBOUNCE_MS = 400; /* see the header: 400, not 250 */
  var QUEUE_MS = 1200; /* blocker re-check, DOM only, no network */
  var LOAD_SETTLE_MS = 600; /* after load, lets the badge settle */
  var DECODE_TIMEOUT_MS = 2500; /* a stalled image never suppresses a message */
  var PRESENT_MAX_MS = 8000; /* hard ceiling on the presentation lock */
  var EXIT_MS = 420; /* == --promo-exit */
  var PROMOTE_MS = 400; /* == --promo-promote */
  var ROW_OK_MS = 1600; /* per-row success flash */
  var DEFAULT_DELAY_MS = 1200; /* used only when data-delay is unreadable */
  var PILL_RETRY_MAX = 10; /* pill waits behind a toast, but not forever */
  var ADD_TIMEOUT_MS = 12000; /* the add's watchdog, see rowAdd() */
  var READ_RETRY_MAX = 3; /* a failed /cart.js read is retried, never dropped */
  var SLOW_RETRY_MS = 15000; /* after the fast retries the engine goes patient, never blind */

  /* TIER B mechanism constants. None of these is a pressure knob the
     owner tunes; they are the physics of a courteous reveal, so they
     live here and not on the host. */
  var TOUCH_HOLD_MS = 1500; /* THE COURTESY HOLD: a reveal waits this long after a touch */
  var ARM_MS = 350; /* THE CLICKABILITY DELAY: the layer ACTS on input this late, and swallows until then */
  var CART_REACH_MS = 3000; /* the checkout-reach window on /cart, measured from the load */

  var refs = null;
  var dead = false; /* the fail-open latch: true means the engine has stopped */
  var isOpen = false;
  var presentJob = null; /* the presentation lock, held AS THE JOB OBJECT */
  var lockedByUs = false; /* true only while WE hold body.overflow-hidden */
  var lastFocused = null;
  var pending = null;
  var debounceTimer = null;
  var showTimer = null;
  var queueTimer = null;
  var slowTimer = null;
  var hideTimer = null;
  var armTimer = null; /* THE CLICKABILITY DELAY's one timer, see reveal() */
  var pillTimer = null;
  var pillWaitTimer = null;
  var pillUntil = 0; /* when the pill currently on screen finishes */
  var pillArmed = false; /* a !has100 -> has100 step was observed here */
  var kicked = false;
  var menuBusy = false; /* one add request at a time out of the menu */
  var menuAddQueue = []; /* THE RAGE QUEUE (owner order 2026-08-03: "make it
     literally add everything even if I am rage clicking"): taps landing
     while an add is in flight queue {id, qty} here instead of dropping.
     The queue drains ONE variant per settle - coalesced, serial, never a
     parallel writer - and is dropped whole on failure or watchdog (an
     unknown outcome may not be machine-gunned) and on a closed box. */

  /* WHO OWNS THE BUSY STATE, and WHICH SHOWING an add belongs to.
     Both are plain counters and both exist for the same reason: an
     add is asynchronous and the box it started in may be gone, or
     recomposed for a different message, by the time it answers.

     addToken   bumped by every add and by every clear. A response
                may only write the busy state while it still holds
                the current token, so a stale request can never
                un-busy a newer one, and clearing the busy state is
                always safe because it takes the token with it.
     showingId  bumped by every reveal(). The presentation half of a
                response (the success morph, the row tint, the
                status copy, the focus move) runs only while the box
                that started the add is still the box on screen. The
                cart half (the badge, the publish, the re-evaluate)
                always runs, because that is truth about the cart
                and not about a card. */
  var addToken = 0;
  var showingId = 0;
  var cartPage = null; /* memoised: a document's pathname cannot change */
  var cartIds = {}; /* variant ids in the cart at the last read */
  var lastCart = null; /* { qty50, has100, itemCount } from the last read */
  var pillCopy = ''; /* cached pill sentence, see resolvePillCopy() */
  var storageOk = true; /* false once localStorage has thrown */
  var observed = typeof WeakSet === 'function' ? new WeakSet() : null;

  /* PER PAGE LOAD, in memory on purpose so a reload really is a new
     load. Reset together on a bfcache restore, where there is no new
     document to reset them for us. */
  var loadAt = Date.now(); /* THE CHECKOUT REACH is measured from here, not from
     performance.timing: a bfcache restore is a new load for this component and
     resets it, and a document that was never navigated has no other honest zero. */
  var lastTouchAt = 0; /* THE COURTESY HOLD's only input, see watchTouch() */
  var warmed = false; /* THE ARTWORK WARM-UP runs once per load, see warmGreet() */
  var hundredShownHere = false; /* THE PAGE CAP (owner 2026-08-03): hundred
     reveals once per page LOAD. Page-scoped by design — any navigation
     resets it, no storage is touched, no other message is governed. It
     exists because a cart edit clears the quiets (doctrine) and the very
     next evaluate could re-open the card on top of the nest's sealing
     ceremony on the same /cart visit. */

  /* THE CART PAGE'S FRESHNESS FLAG. Set by a successful add made
     while standing on the cart template, spent by the close. See
     reloadIfDirty(). */
  var cartDirty = false;

  var CARD_KEYS = ['greet-bundle', 'greet-hundred', 'pair', 'bundle', 'hundred', 'menu'];

  /* The message keys that own a quiet. One list, read by stampQuiet()
     as its guard and by the storage helpers as the shape of `q`, so a
     fifth message cannot be half-added. */
  var QUIET_KEYS = ['greet', 'pair', 'bundle', 'hundred'];

  /* THE MENU SELLS BOTH SIZES out of one card. Liquid renders a head,
     a success panel and a row list for each, tagged data-promo-size,
     and the host's data-menu-size names the trio on screen. The value
     comes from the CTA that opened the menu and nothing else, so a
     size is chosen once per opening and never changes under the
     customer: there is no path from one list to the other without
     closing the box. */
  var MENU_SIZES = ['50', '100'];

  function noop() {}

  /* ─── The fail-open latch ────────────────────────────────────
     Every entry point (listener, timer callback, public method) is
     wrapped. A throw anywhere pulls the whole component off the page
     rather than leaving half a dialog over the storefront. */

  function panic() {
    dead = true;
    try {
      document.removeEventListener('keydown', onKeydown, true);
      clearTimeout(debounceTimer);
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
      clearTimeout(armTimer);
      clearTimeout(pillTimer);
      clearTimeout(pillWaitTimer);
      stopQueue();
      presentJob = null;
      isOpen = false;
      pending = null;
      if (lockedByUs) {
        document.body.classList.remove('overflow-hidden');
        lockedByUs = false;
      }
      if (refs) {
        refs.host.classList.remove('is-open');
        refs.host.classList.remove('is-closing');
        refs.host.hidden = true;
        if (refs.pill) {
          refs.pill.classList.remove('is-open');
          refs.pill.classList.remove('is-leaving');
        }
        if (refs.pillText) refs.pillText.textContent = '';
      }
    } catch (e) {
      /* there is nothing sensible left to do, and nothing to say */
    }
  }

  function guard(fn) {
    return function () {
      if (dead) return undefined;
      try {
        return fn.apply(this, arguments);
      } catch (e) {
        panic();
        return undefined;
      }
    };
  }

  /* ─── Small helpers ──────────────────────────────────────── */

  function each(list, fn) {
    if (!list) return;
    Array.prototype.forEach.call(list, fn);
  }

  function num(v, fallback) {
    var n = typeof v === 'number' ? v : parseInt(v, 10);
    if (typeof n !== 'number' || !isFinite(n)) return typeof fallback === 'number' ? fallback : 0;
    return n;
  }

  /* Size is identified by NORMALISED variant title, never derived
     from price. Same contract the Liquid uses (size_label with the
     spaces stripped and downcased), which is why "50 ml" and "50ml"
     both match on both sides. */
  function norm(t) {
    return String(t || '')
      .replace(/\s/g, '')
      .toLowerCase();
  }

  function routeRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function safeError(message) {
    var err = new Error(message);
    err.ryzeSafe = true;
    return err;
  }

  function isInert(el) {
    return el.hasAttribute('disabled') || el.getAttribute('aria-disabled') === 'true';
  }

  function focusEl(el) {
    if (!el) return;
    try {
      el.focus({ preventScroll: true });
    } catch (e) {
      try {
        el.focus();
      } catch (e2) {
        /* nothing sensible left to do */
      }
    }
  }

  function today() {
    var d = new Date();
    var m = d.getMonth() + 1;
    var day = d.getDate();
    return d.getFullYear() + '-' + (m < 10 ? '0' + m : m) + '-' + (day < 10 ? '0' + day : day);
  }

  /* Memoised: a document's pathname does not change without a
     navigation, and this is consulted from click handlers. Trailing
     slashes and the query are normalised away; the locale prefix
     rides along inside routes.cart_url, so a localised store
     compares correctly without a second rule. */
  function onCartPage() {
    if (cartPage !== null) return cartPage;
    cartPage = false;
    try {
      var url = (window.routes && window.routes.cart_url) || '/cart';
      var here = String(window.location.pathname).replace(/\/+$/, '');
      var want = String(url).split('?')[0].split('#')[0].replace(/\/+$/, '');
      cartPage = here === want;
    } catch (e) {
      cartPage = false;
    }
    return cartPage;
  }

  /* ─── Settings, read LIVE off the host ────────────────────────
     Not one of these is cached, so the theme editor's sliders and
     checkboxes take effect on the next decision without a reload.
     The section writes "0" both when the owner switches a message
     off AND when Liquid could not build the thing it needs. */

  function attr(name) {
    return refs ? refs.host.getAttribute(name) : null;
  }

  function on(name) {
    return attr(name) === '1';
  }

  function delayMs() {
    var n = parseInt(attr('data-delay'), 10);
    return !isFinite(n) || n < 0 ? DEFAULT_DELAY_MS : n;
  }

  function quietMs() {
    var n = parseInt(attr('data-quiet-minutes'), 10);
    if (!isFinite(n) || n < 0) n = 5;
    return n * 60000;
  }

  /* THE DISMISSAL'S LIFE (Tier B (i)). Separate from quietMs() on
     purpose: quietMs() is the machine's short pause and still governs
     the 100 ml breather's arithmetic, while this one is what an X
     costs. Read live like everything else, so the owner can walk it
     back to five minutes from the theme editor without a deploy if
     the attach rate says so. */
  function dismissMs() {
    var n = parseInt(attr('data-dismiss-minutes'), 10);
    if (!isFinite(n) || n < 0) n = 60;
    return n * 60000;
  }

  /* A QUIET ROOM (Tier B (ii)). Liquid decides this from the template
     suffix, never from the pathname: page handles are renameable and
     localised, template bindings are not. */
  function quietRoom() {
    return attr('data-quiet-room') === '1';
  }

  function pillMs() {
    var n = parseInt(attr('data-pill-seconds'), 10);
    if (!isFinite(n) || n <= 0) n = 4;
    return n * 1000;
  }

  /* TENTHS of a second in the schema, so the owner's slider reads
     naturally. 16 means 1.6s. */
  function bundleDelayMs() {
    var n = parseInt(attr('data-bundle-delay'), 10);
    if (!isFinite(n) || n < 0) n = 16;
    return n * 100;
  }

  function sizeKey() {
    return norm(attr('data-size-key'));
  }

  function sizeKey100() {
    return norm(attr('data-size-key-100'));
  }

  /* Which of the menu's two sizes is on screen, and which size a
     rendered head / success panel / row list belongs to. Anything
     that is not the literal '100' is the 50 ml, so a missing or
     mangled attribute lands on the default list rather than on
     nothing at all. */
  function menuSize() {
    return refs && refs.host.getAttribute('data-menu-size') === '100' ? '100' : '50';
  }

  function sizeOf(el) {
    return el && el.getAttribute('data-promo-size') === '100' ? '100' : '50';
  }

  /* No hardcoded fallback for the two size keys, deliberately. If
     Liquid ever failed to write them the arithmetic simply matches
     nothing, which arms only the empty-cart greeting: the component
     goes quiet rather than guessing at what a customer bought. */

  function messageEnabled(msg) {
    if (!refs) return false;
    if (msg === 'greet') {
      if (!on('data-greet-enabled')) return false;
      return !!(refs.cards['greet-bundle'] || refs.cards['greet-hundred']);
    }
    if (msg === 'pair') return on('data-pair-enabled') && !!refs.cards.pair;
    if (msg === 'bundle') return on('data-bundle-enabled') && !!refs.cards.bundle;
    if (msg === 'hundred') return on('data-hundred-enabled') && !!refs.cards.hundred;
    return false;
  }

  /* ─── Storage, one guarded helper, mirrored in memory ─────────
     Shape is fixed by the DOM contract 14.4. Reads never hand a
     caller a live reference into the mirror, so a caller mutating
     what it got back cannot corrupt what is stored. */

  var mem = null; /* mirror of ryze_promo_v1 */
  var memTab = null; /* mirror of ryze_promo_tab */

  /* THE SNAPSHOT CARRIES THREE FACTS, NOT TWO. n is the whole cart's
     item_count, and it is there because q50 and h100 alone cannot see
     a cart that held only other things: a bag of samples emptying
     moves neither of them, so without n the greeting would not re-arm
     and the quiets would not clear on a change the customer plainly
     made. A stored snapshot written before n existed is treated as
     STALE rather than migrated: t is forced to 0, which is the "not
     known yet" case every reader already tests, and the next evaluate
     writes the current shape. */
  function blankState() {
    var q = {};
    var k = {};
    for (var i = 0; i < QUIET_KEYS.length; i++) {
      q[QUIET_KEYS[i]] = 0;
      k[QUIET_KEYS[i]] = 0;
    }
    return { q: q, k: k, s: { q50: -1, h100: -1, n: -1, t: 0 }, d: '' };
  }

  /* THE ONE PLACE A STORED `q` IS READ, and the reason a stored
     object written before `hundred` existed cannot throw or mislead.
     Every key is taken from QUIET_KEYS, not from the object, and each
     goes through num(), which answers 0 for a key that is not there
     (num() at the top of this file: a non-finite parse returns the
     fallback, and the fallback here is its default 0). A missing
     quiet therefore reads as "never dismissed", which is the same
     answer a fresh device gives and the correct one: the customer
     has not dismissed a message that did not exist yet. No migration
     step, no version number and nothing to run once. */
  function readQuiets(into, from) {
    if (!from || typeof from !== 'object') return;
    for (var i = 0; i < QUIET_KEYS.length; i++) {
      into[QUIET_KEYS[i]] = num(from[QUIET_KEYS[i]]);
    }
  }

  /* THE KIND MAP, read by the same rule and for the same reason: keys
     come from QUIET_KEYS, never from the object, and anything that is
     not literally 1 is a machine quiet. A state written before k
     existed therefore reads as all-zeros, which is precisely the old
     behaviour for every quiet already on a customer's device. */
  function readKinds(into, from) {
    if (!from || typeof from !== 'object') return;
    for (var i = 0; i < QUIET_KEYS.length; i++) {
      into[QUIET_KEYS[i]] = from[QUIET_KEYS[i]] === 1 ? 1 : 0;
    }
  }

  function readState() {
    var st = blankState();

    if (mem) {
      readQuiets(st.q, mem.q);
      readKinds(st.k, mem.k);
      st.s.q50 = num(mem.s.q50, -1);
      st.s.h100 = mem.s.h100 === 1 ? 1 : mem.s.h100 === 0 ? 0 : -1;
      st.s.n = num(mem.s.n, -1);
      st.s.t = num(mem.s.t);
      st.d = typeof mem.d === 'string' ? mem.d : '';
    }

    /* THE MIRROR OUTRANKS A STORE WE COULD NOT WRITE TO.
       storageOk is false only when a real storage operation threw,
       and the case that matters is the asymmetric one: iOS Safari
       raises QuotaExceededError from setItem on a full origin while
       getItem keeps happily returning the entry written on an
       earlier visit. Reading that entry back would hand the older
       value to a caller that writeState() has just given a newer one
       in memory, and the quiet a customer just spent with an X would
       be undone about a second later, forever. So once a write has
       failed the mirror is the whole truth for this tab until a
       later write succeeds and re-opens the store. */
    if (!storageOk) return st;

    try {
      var raw = localStorage.getItem(STATE_KEY);
      /* PARSE FAILURE IS NOT STORAGE FAILURE. A hand-edited or
         truncated value says nothing about whether localStorage
         works, and latching the flag on it would make state()
         report a working store as the memory fallback for the rest
         of the page. Its own try, so only the storage call itself
         can move the flag. */
      var p = null;
      try {
        p = raw ? JSON.parse(raw) : null;
      } catch (parseError) {
        p = null;
      }
      if (p && typeof p === 'object') {
        readQuiets(st.q, p.q);
        readKinds(st.k, p.k);
        if (p.s && typeof p.s === 'object') {
          st.s.q50 = num(p.s.q50, -1);
          st.s.h100 = p.s.h100 === 1 ? 1 : p.s.h100 === 0 ? 0 : -1;
          st.s.t = num(p.s.t);
          if (typeof p.s.n === 'number' && isFinite(p.s.n)) {
            st.s.n = p.s.n;
          } else {
            /* Written by an older build. Nothing here is trusted and
               nothing crashes: the snapshot simply reads as unknown. */
            st.s.n = -1;
            st.s.t = 0;
          }
        }
        if (typeof p.d === 'string') st.d = p.d;
      }
    } catch (e) {
      /* storage unavailable: the memory mirror stands in, and the
         whole component degrades to MORE popups, never to a crash
         and never to silence. */
      storageOk = false;
    }

    return st;
  }

  function writeState(st) {
    var q = {};
    var k = {};
    for (var i = 0; i < QUIET_KEYS.length; i++) {
      q[QUIET_KEYS[i]] = num(st.q[QUIET_KEYS[i]]);
      /* A kind without a live quiet is meaningless and would outlive
         what it describes, so it is written only alongside one. */
      k[QUIET_KEYS[i]] = q[QUIET_KEYS[i]] && st.k && st.k[QUIET_KEYS[i]] === 1 ? 1 : 0;
    }
    var obj = {
      q: q,
      k: k,
      /* h100 is written as 0|1 per the contract. The "not known yet"
         case is carried by t === 0, which is what every reader tests
         before it trusts the snapshot at all. */
      s: { q50: num(st.s.q50, -1), h100: st.s.h100 === 1 ? 1 : 0, n: num(st.s.n, -1), t: num(st.s.t) },
      d: typeof st.d === 'string' ? st.d : ''
    };
    mem = obj;
    try {
      localStorage.setItem(STATE_KEY, JSON.stringify(obj));
      /* A write that lands re-opens the store to readState(). This is
         the only way back from a quota failure, and it is enough:
         every quiet and every snapshot change writes. */
      storageOk = true;
    } catch (e) {
      storageOk = false;
    }
  }

  function readTab() {
    var t = { g: 0 };
    if (memTab) t.g = memTab.g ? 1 : 0;
    try {
      var raw = sessionStorage.getItem(TAB_KEY);
      var p = raw ? JSON.parse(raw) : null;
      if (p && typeof p === 'object') t.g = p.g ? 1 : 0;
    } catch (e) {
      /* memory mirror stands in */
    }
    return t;
  }

  function writeTab(t) {
    var o = { g: t.g ? 1 : 0 };
    memTab = o;
    try {
      sessionStorage.setItem(TAB_KEY, JSON.stringify(o));
    } catch (e) {
      /* memory mirror only */
    }
  }

  function greetSeenHere() {
    return readTab().g === 1;
  }

  function markGreetSeenHere() {
    writeTab({ g: 1 });
  }

  function rearmGreet() {
    writeTab({ g: 0 });
  }

  /* THE QUIET, in two kinds since Tier B, and the kind is now the
     caller's to name (R7, round 13 fix): stampQuiet no longer decides
     it alone.

     A DISMISSAL (kind 1) is what an X spends, Escape included: they
     write the same kind even though Escape closes harder (owner call
     2026-08-20). It lives dismiss_minutes, and a cart change does not
     touch it: the customer answered the question this message asks,
     and editing a cart is not a retraction. "AN X IS A SENTENCE" -
     the proposal's own words - and only an X or Escape writes one.

     A MACHINE QUIET (kind 0) is everything else that spends a quiet:
     the 100 ml breather, a backdrop tap, and the accept path
     (onTargetClick). It lives quiet_minutes, it means only "not again
     just yet", and any cart change clears it exactly as it always
     did. A backdrop tap is a mis-tap risk, not a decision - at 1440
     the scrim is ~490px of dimmed page on each side - so it may not
     buy the hour. An accept is not a dismissal at all: the customer's
     own cart change already retires the discriminator that armed the
     message, so the machine quiet only covers the instant before that
     change is read back.

     Both share one timestamp slot per message, so there is still only
     one quiet per message and no two of them can disagree. */
  function stampQuiet(key, kind) {
    if (QUIET_KEYS.indexOf(key) === -1) return;
    var st = readState();
    st.q[key] = Date.now();
    st.k[key] = kind === 1 ? 1 : 0;
    writeState(st);
  }

  function quietLife(st, key) {
    return st.k && st.k[key] === 1 ? dismissMs() : quietMs();
  }

  function quietLeft(key) {
    var st = readState();
    var ts = num(st.q[key]);
    if (!ts) return 0;
    var left = quietLife(st, key) - (Date.now() - ts);
    return left > 0 ? left : 0;
  }

  /* hard is passed by the day roll ONLY. A new day is the one event
     that clears a dismissal, because it is the boundary the owner
     kept from the original doctrine; a cart change clears the machine
     quiets and leaves the answered questions answered. */
  function clearQuiets(st, hard) {
    for (var i = 0; i < QUIET_KEYS.length; i++) {
      var key = QUIET_KEYS[i];
      if (!hard && st.k[key] === 1) continue;
      st.q[key] = 0;
      st.k[key] = 0;
    }
  }

  /* ─── Cart read ─────────────────────────────────────────────
     Two reads can be in flight at once: the queue's tick() against
     fire(), or present()'s revalidation against a badge-observer
     evaluate(). HTTP responses are not ordered, so a read that
     STARTED before one which has already answered describes an older
     cart.

     A SUPERSEDED RESPONSE DECIDES NOTHING. It is not handed to the
     success callback at all, because everything downstream of that
     callback acts on it: track() moves the stored snapshot, counts()
     moves the id map behind the row tags, and present() reveals a
     card off it. It goes to the caller's FAIL path instead, which
     every caller now has, so the decision is deferred and re-read
     rather than taken from an older cart or dropped on the floor. */

  var cartSeq = 0; /* ticket handed to each read */
  var cartSeen = 0; /* the newest ticket that has already answered */

  function fetchCart(cb, fail) {
    var seq = ++cartSeq;
    var answered = false;
    var giveUp = function () {
      if (answered) return;
      answered = true;
      if (typeof fail === 'function') fail();
    };

    fetch(routeRoot() + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(
        guard(function (cart) {
          if (!cart || seq < cartSeen) {
            giveUp();
            return;
          }
          answered = true;
          cartSeen = seq;
          cb(cart);
        })
      )
      ['catch'](function () {
        /* offline, throttled or blocked: the caller's fail path
           decides what to do, and every caller has one. */
        giveUp();
      });
  }

  /* Status before parse. Shopify throttles cart endpoints per IP and
     answers text/plain, which would otherwise reject inside r.json()
     and be indistinguishable from a real failure. */
  function readCart() {
    return fetch(routeRoot() + 'cart.js', {
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    }).then(function (r) {
      if (!r.ok) throw safeError('Cart read failed.');
      return r.json();
    });
  }

  /* ─── The state machine ───────────────────────────────────── */

  /* THE ARITHMETIC IS SCOPED TO THIS SECTION'S OWN CATALOGUE when
     Liquid could resolve it whole, and falls back to the normalised
     variant title when it could not.

     Title matching alone counts ANY product whose variant reads
     "50 ml", which is not what qty50 means: the pair price is a
     variant-scoped Buy-X-Get-Y over the fragrances, so a room spray
     or a sample vial in the same size would arm the pair card and
     then silence it at two, and the discount the card promised
     would never apply. The section therefore publishes the variant
     ids it resolved, and only when its catalogue walk was complete
     (the collection is named and fits inside the scan). Absent or
     empty, the attribute changes nothing and the title match stands
     exactly as before. */
  var idMapCache = {};

  function idMap(name) {
    var raw = attr(name) || '';
    if (!raw) return null;

    var cached = idMapCache[name];
    if (cached && cached.raw === raw) return cached.map;

    var parts = raw.split(',');
    var map = {};
    var any = false;
    for (var i = 0; i < parts.length; i++) {
      var n = parseInt(parts[i], 10);
      if (isFinite(n) && n > 0) {
        map[n] = 1;
        any = true;
      }
    }

    idMapCache[name] = { raw: raw, map: any ? map : null };
    return any ? map : null;
  }

  function counts(cart) {
    var items = (cart && cart.items) || [];
    var k50 = sizeKey();
    var k100 = sizeKey100();
    var allow50 = idMap('data-promo-50-ids');
    var allow100 = idMap('data-promo-100-ids');
    var has100 = false;
    var qty50 = 0;
    var ids = {};
    var summed = 0;
    var i;

    for (i = 0; i < items.length; i++) {
      var t = norm(items[i].variant_title);
      var q = items[i].quantity || 0;
      var id = num(items[i].variant_id, 0);
      var is100 = allow100 ? allow100[id] === 1 : !!(k100 && t === k100);
      var is50 = allow50 ? allow50[id] === 1 : !!(k50 && t === k50);
      if (id) ids[id] = 1;
      summed += q;
      if (is100) has100 = true;
      else if (is50) qty50 += q;
    }

    cartIds = ids;
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : summed;
    lastCart = { qty50: qty50, has100: has100, itemCount: count };
    return lastCart;
  }

  /* Called from decide(), so it sees every fresh cart read and sees
     it before any gate. Idempotent: a second call for the same cart
     changes nothing, which is what lets present() revalidate without
     re-arming or disarming what the first pass decided. */
  function track(c) {
    /* An out-of-order response can no longer reach here: fetchCart()
       routes a superseded read to its caller's fail path instead of
       its success callback, so every cart this sees is the newest
       one that has answered. */
    var st = readState();
    var stamp = today();
    var h100 = c.has100 ? 1 : 0;
    var n = num(c.itemCount);
    var known = st.s.t > 0;
    var changed = false;

    /* A NEW DAY clears every quiet, dismissals included, and re-arms
       the greeting in a tab that has been sitting open across
       midnight. This is the one hard clear. */
    if (st.d !== stamp) {
      clearQuiets(st, true);
      st.d = stamp;
      changed = true;
      rearmGreet();
    }

    if (known) {
      /* n is in the comparison, so a cart holding nothing this
         component sells still counts as a cart that MOVED. */
      var moved = st.s.q50 !== c.qty50 || st.s.h100 !== h100 || st.s.n !== n;

      /* A CART-STATE CHANGE CLEARS THE MACHINE QUIETS, AND ONLY
         THOSE (Tier B (i), owner 2026-08-19). A customer who touches
         their cart is telling us the situation changed, which is a
         good reason to lift a breather the engine imposed on itself.
         It is NOT a reason to re-ask a question the customer already
         answered with an X, and re-asking it was the single behaviour
         the field survey found no surveyed brand does. The partition
         keeps this honest: a cart edit that moves the customer into a
         DIFFERENT state meets that state's own message, which was
         never dismissed. */
      if (moved) {
        clearQuiets(st, false);
        changed = true;
      }

      /* THE PILL IS A TRANSITION, not a state. Armed only on the
         step from no 100 ml to a 100 ml, and only for the page that
         observed the step. Because the snapshot is shared across
         tabs, whichever page sees the step first consumes it, and a
         tab opened afterwards finds h100 already 1 and shows
         nothing. A customer who simply arrives with a 100 ml already
         in the cart has no prior snapshot at all, so `known` is
         false and no pill is armed. */
      if (st.s.h100 === 0 && h100 === 1) pillArmed = true;

      /* The greeting re-arms on the step back to an empty cart, in
         every tab, because the flag it re-arms is per tab and this
         is the shared fact that justifies it. n is tested alongside
         the two size counts, so a bag that held only other products
         and then emptied re-arms it just the same. */
      if ((st.s.q50 > 0 || st.s.h100 === 1 || st.s.n > 0) && n === 0) rearmGreet();
    }

    if (!known || st.s.q50 !== c.qty50 || st.s.h100 !== h100 || st.s.n !== n) {
      st.s.q50 = c.qty50;
      st.s.h100 = h100;
      st.s.n = n;
      st.s.t = Date.now();
      changed = true;
    }

    if (changed) writeState(st);
  }

  function decide(cart) {
    var c = counts(cart);
    track(c);

    /* THE PARTITION. Disjoint by arithmetic, and the order below is
       only a reading order: no two branches can both be true.
       qty50 alone separates greet (0, with nothing else in the bag),
       pair (1), bundle (0) and hundred (>= 2) into three groups, and
       has100 separates the two that share qty50 == 0. The state left
       over is qty50 >= 2 && has100, which arms nothing: both offers
       are already taken. */
    if (c.itemCount === 0) return { message: 'greet' };
    if (c.qty50 === 1) return { message: 'pair' };
    if (c.qty50 === 0 && c.has100) return { message: 'bundle' };
    if (c.qty50 >= 2 && !c.has100) return { message: 'hundred' };
    return null;
  }

  /* THE GATE. Rewritten from scratch, not ported: the archived
     suppressed() was where the seen map, the session dismissal and
     the shared cooldown all met, and all three are retired. */
  function due(d) {
    if (!d || !refs) return false;
    if (!messageEnabled(d.message)) return false;

    /* THE QUIET ROOMS (Tier B (ii)). Nothing this component sells is
       due on a tracking or returns page, whatever the cart says. This
       is a hard NO rather than a blocker: there is no later moment on
       this page when it becomes appropriate, so the decision is
       dropped, not queued. The pill is not routed through here and
       still rises: it confirms an add, it does not sell. */
    if (quietRoom()) return false;

    if (d.message === 'hundred' && hundredShownHere) return false;

    if (d.message === 'greet') {
      /* Once per tab visit. sessionStorage is per tab, which is
         exactly the scope this rule wants and the only rule in the
         component that may use it. */
      if (greetSeenHere()) return false;
      return quietLeft('greet') <= 0;
    }

    /* THE CART PAGE EXCEPTION IS RETIRED (proposal 1b, owner
       2026-08-19). It used to hand /cart one show per load that
       ignored every quiet, which is how a dismissed card came back on
       the one surface where the customer's next tap is Checkout. Cart
       state messages still run on /cart; they simply obey the same
       quiet as everywhere else. What protects the reach itself is a
       BLOCKER, not this gate: see uiBlocker()'s checkout-reach arm,
       which defers rather than drops. */
    return quietLeft(d.message) <= 0;
  }

  /* ─── Blockers. Blocked means QUEUED, never dropped ──────── */

  /* THE SHEET (CODE-19, 2026-10-19). ryze-promo.css now loads
     non-blocking (media print, swapped to all on load), so this script
     can run before it applies. Nothing is revealed until it has; the
     host's own --promo-z token is the proof. A sheet that never arrives
     keeps the moment queued, never painted unstyled. */
  function stylesReady() {
    if (!refs || !refs.host) return false;
    try {
      return getComputedStyle(refs.host).getPropertyValue('--promo-z').trim() !== '';
    } catch (e) {
      return true;
    }
  }

  function uiBlocker() {
    if (document.visibilityState !== 'visible') return 'hidden-tab';

    if (!stylesReady()) return 'styles';

    /* THE RESTORE HOLDS THE SCREEN (W6 2026-10-18). On a reload or a
       back/forward arrival snippets/ryze-restore.liquid keeps the body
       invisible (html.ryze-restoring, at most ~650 ms) while it puts
       the visitor back on her spot. A card revealed into that hold
       would lock the body over a page that is not yet in place, so the
       moment queues and the queue spends it once the class is gone. */
    if (document.documentElement.classList.contains('ryze-restoring')) return 'restoring';

    /* THE COURTESY HOLD (Tier B / proposal 0a). A finger that has
       just landed is already committed to something on the page, and
       a layer arriving on top of it steals that tap. So a reveal
       waits until the screen has been still for TOUCH_HOLD_MS. This
       is a blocker and not a gate, so the moment is deferred and the
       queue spends it as soon as the thumb rests. On a mouse the
       clock never starts, because pointerdown is filtered to touch
       and pen. */
    if (lastTouchAt && Date.now() - lastTouchAt < TOUCH_HOLD_MS) return 'touch-hold';

    /* THE CHECKOUT REACH (proposal 1b). The first seconds of a /cart
       load belong to the thumb already travelling toward Checkout.
       Nothing may paint over that, whatever the cart earns. */
    if (onCartPage() && Date.now() - loadAt < CART_REACH_MS) return 'checkout-reach';

    if (document.querySelector('.ryze-mobile-menu.is-open')) return 'mobile-menu';
    /* The bundle-builder picker is a native <dialog>. Ours
       deliberately is not, so this test can never see our own box. */
    if (document.querySelector('dialog[open]')) return 'dialog';
    if (document.querySelector('details[open].menu-opening')) return 'details-menu';
    if (document.querySelector('.ryze-quick-add-overlay.active, .ryze-quick-add-overlay.is-open')) {
      return 'quick-add';
    }
    /* THE HEADER SEARCH IS A MOMENT TOO. It opens no dialog, sets no
       scroll lock and owns no overlay, so nothing above sees it, but
       the customer is typing into a field this layer would paint
       over and reveal() would take the focus off mid-query, closing
       the phone keyboard. ryze-custom.js writes both of these. */
    if (document.querySelector('.ryze-nav__search-bar.is-open, .ryze-nav.search-active')) {
      return 'search';
    }
    /* ANY FIELD IN USE IS A MOMENT (CODE-13, 2026-10-18). The two
       selectors above name the retired nav search bar; the general rule
       is the customer typing anywhere (the search sheet, the returns or
       tracking form, the newsletter): reveal() would take the focus and
       close the phone keyboard mid-word. */
    var typing = document.activeElement;
    if (typing && typing !== document.body &&
        (typing.isContentEditable || /^(TEXTAREA|SELECT)$/.test(typing.tagName) ||
         (typing.tagName === 'INPUT' && !/^(radio|checkbox|button|submit|reset|range|color|file|image)$/i.test(typing.type))) &&
        !(refs && refs.host && refs.host.contains(typing))) {
      return 'typing';
    }
    /* Always null on this store: there is no cart drawer. Harmless,
       and correct, if one is ever added. */
    var drawer = document.querySelector('cart-drawer');
    if (drawer && (drawer.classList.contains('active') || drawer.hasAttribute('open'))) return 'cart-drawer';
    /* THE CART TOAST OWNS ITS MOMENT. It sits at z 10000, above this
       whole layer, and it fires from the same add paths this engine
       listens to. While one is on screen a present queues and
       retries when it clears. */
    if (document.querySelector('.ryze-ctoast.ryze-ctoast--in')) return 'toast';
    /* Someone else owns the scroll lock, so someone else owns the
       screen. */
    if (!lockedByUs && document.body.classList.contains('overflow-hidden')) return 'scroll-lock';
    return '';
  }

  function blockedByUi() {
    return uiBlocker() !== '';
  }

  /* RULING 4, EXPRESSED AS A BLOCKER: pill first, card after, never
     both at once. An ARMED pill means one is about to rise; a pill
     already on screen owns the bottom of the viewport until
     pillUntil. A card revealed over either would bury a confirmation
     the customer never got to read, because the pill sits at 1090
     and this layer at 1100. Deferring instead is free: presentDelay()
     already adds bundle_delay on top of whatever the pill has left. */
  function pillBusy() {
    if (pillArmed) return true;
    return pillUntil > Date.now();
  }

  function blocked() {
    /* A box already on screen and a box still loading its artwork
       both mean the screen is spoken for. A pill means it is, or is
       about to be. */
    if (isOpen || presentJob) return true;
    if (pillBusy()) return true;
    return blockedByUi();
  }

  /* The pill is armed inside track(), which runs from EVERY decide(),
     so it must be spent from every one of them too. Consumed only by
     tick(), an arming seen first by fire() or by present()'s
     revalidation would sit latched, blocked() would answer true for
     the life of the page, and the queue would poll a decision it can
     never spend. showPill() clears the flag on every path it takes,
     including the one where it gives up waiting behind a toast. */
  function raisePill() {
    if (pillArmed) showPill(0);
  }

  /* ─── Scheduling ──────────────────────────────────────────── */

  function evaluate() {
    if (!resolve()) return;
    readRetry = 0;
    /* A real trigger supersedes the patient loop: the debounced tick
       it schedules IS the next read, so the slow one stands down. */
    clearTimeout(slowTimer);
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(guard(tick), DEBOUNCE_MS);
  }

  /* A READ THAT FAILED IS NOT AN ANSWER. Shopify throttles cart
     endpoints per IP and this store already reads /cart.js every two
     seconds on the cart template, so a 429 or an offline blip at
     exactly the wrong moment is ordinary. Dropping the pass would
     forfeit the cart page's guaranteed show for that whole page
     load, on a page where nothing else is going to fire a trigger.
     Bounded, so a genuinely dead connection costs three reads and
     then waits for a real trigger. */
  var readRetry = 0;

  function retryRead() {
    if (readRetry >= READ_RETRY_MAX) {
      /* The fast retries are spent. Going silent here left a
         throttled page with no way back until the next trigger, and
         a customer idling on a quiet page may never fire one: the
         exact moment Shopify's per-IP cart throttling bites is a
         heavy add-and-remove testing run, which is when the owner
         is watching. So the engine goes PATIENT instead of blind:
         one slow read at a time, visible pages only, and the first
         success (or any real trigger) stands the loop down. */
      slowRetry();
      return;
    }
    readRetry++;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(guard(tick), QUEUE_MS);
  }

  function slowRetry() {
    clearTimeout(slowTimer);
    slowTimer = setTimeout(
      guard(function () {
        if (document.visibilityState !== 'visible') {
          /* No network for a hidden tab; check again next round. */
          slowRetry();
          return;
        }
        tick();
      }),
      SLOW_RETRY_MS
    );
  }

  function tick() {
    fetchCart(
      function (cart) {
        readRetry = 0;
        var d = decide(cart);
        /* The pill first, always, so its finish time is known before
           the card's delay is computed. Ruling 4: pill, then card. */
        raisePill();
        schedule(d);
      },
      function () {
        retryRead();
      }
    );
  }

  /* The gap the card owes the pill. While a pill is on screen the
     card waits for it to finish and then for bundle_delay on top, so
     the two never overlap and the pill is never the thing a customer
     misses because a dialog landed over it. */
  function presentDelay() {
    var base = delayMs();
    var left = pillUntil - Date.now();
    if (left > 0) {
      var withGap = left + bundleDelayMs();
      if (withGap > base) base = withGap;
    }
    return base;
  }

  function schedule(d) {
    clearTimeout(showTimer);

    if (!due(d)) {
      pending = null;
      stopQueue();
      return;
    }

    pending = d;

    if (blocked()) {
      queue(QUEUE_MS);
      return;
    }

    showTimer = setTimeout(guard(fire), presentDelay());
  }

  /* Pure DOM polling: no network while a blocker is up, and it stops
     the moment nothing is pending. This is what turns "blocked" into
     "deferred" rather than "dropped". */
  function queue(delay) {
    stopQueue();
    queueTimer = setTimeout(
      guard(function () {
        queueTimer = null;
        if (!pending) return;
        if (blocked()) {
          queue(QUEUE_MS);
          return;
        }
        clearTimeout(showTimer);
        showTimer = setTimeout(guard(fire), presentDelay());
      }),
      delay
    );
  }

  function stopQueue() {
    if (queueTimer) {
      clearTimeout(queueTimer);
      queueTimer = null;
    }
  }

  function defer(d) {
    pending = d;
    queue(QUEUE_MS);
  }

  /* First gate. The cart is read again here, so a decision taken
     more than a second ago is never carried into present()
     unexamined. It is not the LAST gate: present() re-runs the same
     test on the far side of the artwork decode. */
  function fire() {
    fetchCart(
      function (cart) {
        readRetry = 0;
        var d = decide(cart);
        /* This read can be the one that first sees the 100 ml step,
           so the pill is spent here exactly as it is in tick(). */
        raisePill();
        if (!due(d)) {
          pending = null;
          stopQueue();
          return;
        }
        if (blocked()) {
          defer(d);
          return;
        }
        present(d);
      },
      function () {
        /* schedule() has already set pending, so a dropped read here
           strands a decision with no timer left to spend it. Hold it
           and let the queue try again, which is what present() does
           with the same failure. */
        if (pending) defer(pending);
        else retryRead();
      }
    );
  }

  /* ─── Presentation ──────────────────────────────────────────
     present() opens nothing. It claims the lock, attaches src to
     artwork that ships with none, awaits decode(), and only on the
     far side of that wait does it re-run the gate and reveal. That
     wait is hundreds of ms and capped at DECODE_TIMEOUT_MS, which is
     long enough for the cart to change, for a blocker to open, and
     for a second trigger to arrive.

     THE LOCK IS THE JOB OBJECT. Every callback re-tests
     presentJob === job before touching anything, so a job cancelled
     by hide(), unloaded with the section, or timed out can never
     reach reveal(), and finish() can never release a lock a newer
     job now owns. ───────────────────────────────────────────── */

  function cancelPresent() {
    if (!presentJob) return;
    clearTimeout(presentJob.timer);
    presentJob = null;
  }

  function present(d) {
    if (!refs || isOpen || presentJob) return false;

    var job = { timer: null };
    presentJob = job;

    /* Nothing may leave the lock held. loadArt() caps its own wait,
       but a fetch that never settles does not, and a stuck lock
       would silence the component for the rest of the page. */
    job.timer = setTimeout(
      guard(function () {
        if (presentJob === job) presentJob = null;
      }),
      PRESENT_MAX_MS
    );

    var finish = function () {
      if (presentJob !== job) return;
      clearTimeout(job.timer);
      presentJob = null;
    };

    /* The host is still hidden here, so this composes the box out of
       sight. Every presentation starts on the message view: a box
       that reopened on the menu, or worse on a success confirmation,
       would be describing a cart that has moved on. */
    applyMessage(d.message);

    loadArts(artsFor(d.message), function () {
      /* THE FAR SIDE. Nothing below trusts a value decided before
         the decode: the whole gate is re-run against live state. */
      if (presentJob !== job) return;

      if (!refs || isOpen) {
        finish();
        return;
      }

      /* The pill is tested on BOTH sides of the decode. A 100 ml add
         made while the artwork was decoding arms one, and a card
         revealed on top of it would bury the confirmation under the
         scrim for its whole life. Deferring hands the moment back to
         the pill and presentDelay() puts the card behind it. */
      if (blockedByUi() || pillBusy()) {
        finish();
        defer(d);
        return;
      }

      fetchCart(
        function (cart) {
          if (presentJob !== job) return;

          var fresh = decide(cart);
          raisePill();
          if (!fresh || fresh.message !== d.message || !due(fresh)) {
            /* The decision no longer holds: the customer completed
               the pair inside the decode, or another message became
               the right one. ABANDON SILENTLY. Nothing is recorded
               and no quiet is stamped, so the message stays armed,
               and the machine restarts from a fresh read so whatever
               the cart now deserves is scheduled normally. */
            finish();
            evaluate();
            return;
          }

          if (!refs || isOpen || blockedByUi() || pillBusy()) {
            finish();
            defer(fresh);
            return;
          }

          finish();
          reveal(fresh);
        },
        function () {
          if (presentJob !== job) return;
          /* No cart, so the decision cannot be confirmed. Never
             guess: hold it and let the queue try again. */
          finish();
          defer(d);
        }
      );
    });

    return true;
  }

  /* The artwork ships with no src at all, so a customer who never
     qualifies downloads nothing. src is attached here and decode()
     awaited, so a media block is never revealed empty. The timeout
     means a stalled image degrades to showing the message anyway
     rather than swallowing it.

     The image is rendered whole, never cropped: the stylesheet
     declares no ratio and no positioning on it, so the MEDIA SIZES
     THE BOX and this function does not care what shape the file is. */
  function loadArt(img) {
    return new Promise(function (resolve_) {
      if (!img) {
        resolve_();
        return;
      }

      if (!img.getAttribute('src')) {
        var ss = img.getAttribute('data-srcset');
        var s = img.getAttribute('data-src');
        if (ss) img.setAttribute('srcset', ss);
        if (s) img.setAttribute('src', s);
      }

      /* THE POSTER RIDES WITH THE ART (W1 2026-10-18, site audit #10).
         The card's film used to carry a live poster="" attribute, and a
         browser fetches a poster the moment the element is parsed, hidden
         or not: ~240 KB of promo stills on every page view, including for
         a visitor who had already closed the promo. The poster now ships as
         data-poster and is promoted here, on the same call that attaches
         the still, so it arrives exactly when the art does (present() or
         the greeting warm-up) and never for a card that is not shown. */
      var media = img.parentNode;
      var film = media && media.querySelector ? media.querySelector('video[data-poster]') : null;
      if (film && !film.getAttribute('poster')) {
        film.setAttribute('poster', film.getAttribute('data-poster'));
      }

      var settled = false;
      var done = function () {
        if (settled) return;
        settled = true;
        resolve_();
      };

      setTimeout(done, DECODE_TIMEOUT_MS);

      try {
        if (typeof img.decode === 'function') {
          img.decode().then(done)['catch'](done);
        } else if (img.complete) {
          done();
        } else {
          img.addEventListener('load', done);
          img.addEventListener('error', done);
        }
      } catch (e) {
        done();
      }
    });
  }

  /* The greeting shows two cards at once, so two stills must be in
     hand before either is revealed. Each one carries its own
     DECODE_TIMEOUT_MS ceiling, so the wait cannot compound. */
  function loadArts(imgs, cb) {
    var total = imgs.length;
    var settled = 0;
    var fired = false;
    var finish = guard(function () {
      settled++;
      if (settled < total || fired) return;
      fired = true;
      cb();
    });

    if (!total) {
      cb();
      return;
    }

    for (var i = 0; i < total; i++) {
      loadArt(imgs[i]).then(finish)['catch'](finish);
    }
  }

  function artsFor(msg) {
    var out = [];
    var keys = msg === 'greet' ? ['greet-bundle', 'greet-hundred'] : [msg];
    for (var i = 0; i < keys.length; i++) {
      var card = refs.cards[keys[i]];
      if (!card) continue;
      var img = card.querySelector('[data-promo-art]');
      if (img) out.push(img);
    }
    return out;
  }

  /* ─── The view, expressed as two host attributes ─────────────
     data-message and data-view are the ONLY things that decide what
     is on screen; the stylesheet does the rest. Nothing is built,
     nothing is moved, nothing is reparented. Reparenting would blow
     the focus trap and would feed the two whole-body
     MutationObservers that already run on every page. */

  function eachCard(fn) {
    for (var i = 0; i < CARD_KEYS.length; i++) {
      var card = refs.cards[CARD_KEYS[i]];
      if (card) fn(CARD_KEYS[i], card);
    }
  }

  function resetCards() {
    eachCard(function (key, card) {
      card.classList.remove('is-dominant');
      card.classList.remove('is-peek');
      card.classList.remove('is-centering');
      card.classList.remove('is-solo');
      card.classList.remove('is-leaving');
      /* hidden is used on the two greeting cards ONLY, and only to
         take a dismissed one out of the stack. Restoring it here is
         what makes the next greeting whole again. */
      if (key === 'greet-bundle' || key === 'greet-hundred') card.hidden = false;
    });

    if (refs.menu) refs.menu.classList.remove('is-success');
    /* BOTH success panels, not only the one the last opening used.
       is-success comes off the card, so a panel left un-hidden would
       be composed back in on the next opening of the OTHER size. */
    for (var s = 0; s < MENU_SIZES.length; s++) {
      var panel = refs.successes[MENU_SIZES[s]];
      if (panel) panel.hidden = true;
    }
    setStatus('');
    announce('');
    each(rows(), function (row) {
      row.classList.remove('is-added');
      row.classList.remove('is-error');
    });

    /* THE BUSY STATE IS COMPOSED AWAY WITH EVERYTHING ELSE. It used
       to survive a close, because only the request that set it, its
       watchdog, or a theme-editor re-render ever cleared it: a
       customer who closed the box on a slow add and was shown a new
       card a second later found every Add silently inert and one
       spinner still turning on a row they had not touched. Clearing
       it here is safe because clearBusy() takes the add token with
       it, so the request still in flight can no longer write the
       busy state of the box that replaced its own. */
    clearBusy();
  }

  function applyMessage(msg) {
    if (!refs) return;
    refs.host.setAttribute('data-message', msg || '');
    refs.host.setAttribute('data-view', 'message');
    resetCards();

    if (msg === 'greet') {
      var gb = refs.cards['greet-bundle'];
      var gh = refs.cards['greet-hundred'];
      refs.host.setAttribute('data-greet-focus', 'bundle');
      if (gb && gh) {
        gb.classList.add('is-dominant');
        gh.classList.add('is-peek');
      } else if (gb) {
        gb.classList.add('is-solo');
      } else if (gh) {
        gh.classList.add('is-solo');
        refs.host.setAttribute('data-greet-focus', 'hundred');
      }
      return;
    }

    if (refs.cards[msg]) refs.cards[msg].classList.add('is-solo');
  }

  /* The card that currently owns the screen. Used for the accessible
     name, for focus, and for the film policy. Deliberately computed
     from the attributes rather than from what is visible, because it
     is consulted while the host is still hidden. */
  function activeCard() {
    if (!refs) return null;
    if (refs.host.getAttribute('data-view') === 'menu') return refs.menu;
    var msg = refs.host.getAttribute('data-message');
    if (msg === 'greet') {
      var key = refs.host.getAttribute('data-greet-focus') === 'hundred' ? 'greet-hundred' : 'greet-bundle';
      return refs.cards[key] || refs.cards['greet-bundle'] || refs.cards['greet-hundred'] || null;
    }
    return refs.cards[msg] || null;
  }

  /* THE HEADING A CUSTOMER CAN ACTUALLY SEE. Every message card has
     exactly one, so querySelector is the answer there. The menu has
     a head AND a success panel FOR EACH SIZE, and a plain
     querySelector would always hand back the 50 ml head: the dialog
     would be named after an element that is display:none, and focus
     would be moved into one. So the menu is resolved by the size
     that is open, and by whether the success morph has run. */
  function cardTitle(card) {
    if (!card || !refs) return null;
    if (card !== refs.menu) return card.querySelector('.ryze-promo__title');

    var size = menuSize();
    var panel = card.classList.contains('is-success') ? refs.successes[size] : null;
    var title = panel ? panel.querySelector('.ryze-promo__title') : null;
    if (!title && refs.heads[size]) title = refs.heads[size].querySelector('.ryze-promo__title');
    /* Last resort only: a card with neither, which the Liquid cannot
       produce, still names the dialog rather than leaving a stale id. */
    return title || card.querySelector('.ryze-promo__title');
  }

  /* The dialog's accessible name has to be the heading the customer
     can actually see, or a screen reader announces a card they are
     no longer on. Re-pointed after every message change, view change
     and greeting promotion. */
  function pointLabel() {
    if (!refs) return;
    var title = cardTitle(activeCard());
    if (title && title.id) refs.dialog.setAttribute('aria-labelledby', title.id);
  }

  /* FOCUS ALWAYS GOES TO THE HEADING, NEVER TO THE FIRST ADD BUTTON.
     Two reasons, and the first is a purchase the customer did not
     make: a keyboard customer holding Enter on a CTA would land on a
     live add-to-cart button and the next auto-repeat would press it.
     Second, focus arriving on "Add Como" announces a product instead
     of the question being asked. The headings carry tabindex="-1" so
     they are focusable without joining the tab order, and
     focusables() excludes them, so the next Tab still advances
     natively to the first control. */
  function focusHeading() {
    focusEl(cardTitle(activeCard()) || refs.dialog);
  }

  /* ─── Reveal and hide ────────────────────────────────────── */

  /* THE ARM WINDOW, in one place because TWO events open it: a reveal,
     and a promotion (see promoteGreet). Both put a full-size card with
     a live CTA under a finger that is already moving, so both owe the
     customer the same ARM_MS of deafness. Written once so the two can
     never drift apart.

     The timer is keyed to THIS showing. A reveal that is replaced
     inside the window would otherwise arm its successor early, and
     hide() cancels it so a closing box can never arm at all. */
  function armWindow() {
    if (!refs) return;
    clearTimeout(armTimer);
    refs.host.classList.remove('is-armed');
    var armFor = showingId;
    armTimer = setTimeout(
      guard(function () {
        if (!refs || !isOpen || showingId !== armFor) return;
        refs.host.classList.add('is-armed');
      }),
      ARM_MS
    );
  }

  function reveal(d) {
    if (!refs || isOpen) return;

    isOpen = true;
    /* A NEW SHOWING. Anything still in flight from the last one may
       still correct the cart, but it may no longer write on this
       box: it was composed for a message that has been replaced. */
    showingId++;
    /* The layer was sealed on the way out of the previous showing. */
    refs.host.removeAttribute('inert');
    pending = null;
    stopQueue();
    clearTimeout(showTimer);
    clearTimeout(hideTimer);

    applyMessage(d.message);

    /* Once per tab visit for the greeting, spent by the REVEAL and
       never by the decision, so a decision abandoned on the far side
       of the decode costs nothing. The cart page's grace show used to
       be spent here too and is retired with it (Tier B / 1b). */
    if (d.message === 'greet') markGreetSeenHere();

    /* THE BREATHER (owner order 2026-08-03, from the owner's field report: the
       100 ml card pounced on every page while he browsed). After a REVEAL
       the hundred message rests for data-hundred-breather minutes on this
       device even without an X — a future-dated stamp on the SAME quiet
       slot, so every standing rule governs it unchanged: any cart change
       clears it, a new day clears it, and an X simply re-stamps the
       slot as a real dismissal. 0 in the theme editor turns it off. No
       other message is touched.

       IT IS A MACHINE QUIET, KIND 0, and explicitly stamped as one
       (Tier B): nobody dismissed anything here, so a cart change must
       still lift it. Writing the kind rather than leaving it alone
       also stops a breather inheriting the kind of a dismissal that
       the day roll or a cart change had already emptied. */
    if (d.message === 'hundred') {
      hundredShownHere = true;
      var breatherMin = num(attr('data-hundred-breather'), 0);
      if (breatherMin > 0) {
        var stBr = readState();
        var extra = breatherMin * 60000 - quietMs();
        stBr.q.hundred = Date.now() + (extra > 0 ? extra : 0);
        stBr.k.hundred = 0;
        writeState(stBr);
      }
    }

    primeRows();
    syncRows();

    lastFocused = document.activeElement;
    refs.host.hidden = false;
    refs.host.classList.remove('is-closing');

    /* Never body.style.overflow: the RYZE mobile menu owns the
       inline form and the two do not clear each other. And only
       remove on close what we added. */
    if (!document.body.classList.contains('overflow-hidden')) {
      document.body.classList.add('overflow-hidden');
      lockedByUs = true;
    }

    /* Reflow, so the entrance transition has two frames to run
       between. */
    void refs.host.offsetWidth;
    refs.host.classList.add('is-open');

    /* THE CLICKABILITY DELAY (Tier B / proposal 0b, the Baymard and
       AdMob pattern), REVISED BY OWNER ORDER 2026-08-20 into THE
       SWALLOW. is-open arms the layer's pointer events on frame one
       again, and is-armed - ARM_MS later - is what arms the HANDLER.
       In that window the layer is visible, opaque to pointers and
       deaf: a tap already travelling is absorbed by the scrim and
       does nothing at all, instead of leaking through to whatever
       page element happened to be under a card that had just
       arrived. Only the close X acts (see the swallow in bind()),
       because the one thing an unwanted layer must never do is
       refuse to be closed.

       THE KEYBOARD IS NOT EXEMPT, and the comment that used to say so
       was wrong: Enter or Space on a focused control synthesises a
       click, so the window swallows it exactly as it swallows a tap,
       which is the same protection against a keystroke already in
       flight when the layer arrived. Escape and Tab are unaffected -
       they are read by onKeydown, which the arm never gates. */
    armWindow();

    syncFilms();
    pointLabel();
    focusEl(refs.dialog);
    focusHeading();
    document.addEventListener('keydown', onKeydown, true);
  }

  /* keepFocus is passed as true by exactly one caller, the CTA that
     is about to deliver focus to the section the customer asked for.
     Escape, the X and the backdrop pass nothing and keep the
     restore, which is right for them. The test is strict, so a stray
     Event argument can never suppress it. */
  function hide(keepFocus) {
    cancelPresent();

    if (!refs || !isOpen) return;

    isOpen = false;
    menuAddQueue.length = 0; /* CODE-06: no queued tap outlives its box */
    /* The arm comes off with is-open, and its timer dies here: a box
       on its way out may not become interactive on the far side of a
       timer that outlived it. */
    clearTimeout(armTimer);
    refs.host.classList.remove('is-armed');
    refs.host.classList.remove('is-open');
    refs.host.classList.add('is-closing');
    /* THE LAYER LEAVES THE TAB ORDER NOW, NOT IN 420 MS. is-closing
       removes pointer events and nothing else, so for the whole exit
       window the dismissed card's X and CTA were still focusable and
       the first Tab landed on a clipped sentinel that carries
       aria-hidden, where a screen reader announces nothing at all.
       inert is the one thing that takes a rendered subtree out of
       both the tab order and the accessibility tree without touching
       a pixel, so the fade still runs. focusables() reads it too,
       for the trap. A browser without inert behaves as before. */
    refs.host.setAttribute('inert', '');
    document.removeEventListener('keydown', onKeydown, true);
    stopFilms();

    if (lockedByUs) {
      document.body.classList.remove('overflow-hidden');
      lockedByUs = false;
    }

    var back = keepFocus === true ? null : lastFocused;
    lastFocused = null;
    if (back && back !== document.body && typeof back.focus === 'function' && document.contains(back)) {
      focusEl(back);
    } else if (keepFocus !== true) {
      /* The component opens itself, so there usually is no invoker,
         and focusing <body> is not equivalent: several browsers then
         send the next Tab to the URL bar.
         MAIN, NOT THE RETURN SPAN, WHEN THERE IS ONE. This section
         is registered in the footer group and renders last, so its
         return span is the final tabbable node in the document:
         parking focus there produced the exact ejection to browser
         chrome it was written to prevent. #MainContent is Dawn's own
         main landmark, it already carries tabindex="-1", and the
         next Tab continues into the page instead of out of it. The
         span stays as the fallback for a layout without one, and
         preventScroll keeps the viewport where the customer left it. */
      focusEl(document.getElementById('MainContent') || refs.ret);
    }

    clearTimeout(hideTimer);
    hideTimer = setTimeout(
      guard(function () {
        if (isOpen || !refs) return;
        refs.host.hidden = true;
        refs.host.classList.remove('is-closing');
        /* Composed back to its rest state only once it is out of
           sight, so nothing flashes on the way out. */
        applyMessage(refs.host.getAttribute('data-message') || '');
      }),
      EXIT_MS
    );

    /* State changes that arrived while the box was open apply now.
       evaluate() is debounced and re-reads the cart, so this is one
       decision from one fresh fact, never a replay of a stale one. */
    evaluate();
  }

  /* ─── The greeting choreography ─────────────────────────────
     X on one card promotes the other to the centre and stamps
     NOTHING. The greet quiet is one message's quiet, and it is spent
     only when BOTH cards are gone.

     ONE MECHANISM, TWO DISPOSITIONS (owner order 2026-08-20). The
     promotion itself is a class swap plus the row swap that
     data-greet-focus carries, and both callers want exactly that.
     What they disagree about is the card being displaced: the X has
     dismissed it, so it LEAVES; a tap on the peeking strip has
     dismissed nothing, so it takes the peek pose the promoted card
     just vacated and the greeting stays whole. `swap` is that one
     difference, and there is no second promotion path.

     Escape reaches neither: it takes the hard-close path in dismiss()
     and never calls here, so a keyboard user asking to get out gets
     out on the first press with the partner card left exactly as it
     is. */

  function promoteGreet(dismissedKey, swap) {
    var otherKey = dismissedKey === 'greet-bundle' ? 'greet-hundred' : 'greet-bundle';
    var leaving = refs.cards[dismissedKey];
    var alive = refs.cards[otherKey];

    /* Both conditions are tested, and both now say the same thing: a dismissed
       card carries `hidden` and is-leaving from the same tick. is-leaving is
       kept in the test anyway, because it is the state's name and the two must
       never be able to disagree. Refusing here falls through to the caller's
       stampQuiet('greet') plus hide(), which is the correct answer once there
       is no partner left to promote. */
    if (!leaving || !alive || alive.hidden || alive.classList.contains('is-leaving')) return false;

    /* THE DISMISSED CARD LEAVES THE LAYOUT IN THE SAME TICK IT IS
       DISMISSED. It used to keep its grid row for EXIT_MS while
       is-leaving described opacity and transform and no geometry at
       all, so the ghost inflated from the 46px peek strip to its
       full content height, the row assignment flipped under it, and
       the survivor was centred against two cards and then snapped
       when the timer finally set hidden: two un-animated jumps and a
       full-size ghost of the card the customer had just closed. It
       also stayed focusable the whole time, so the trap could put
       the focus ring on the X of a card that was no longer there.

       hidden now lands immediately. The class stays for the DOM
       contract's state table and for the re-entrancy test above, and
       the choreography the owner asked for is unchanged, because it
       was never the dismissed card's animation: it is the survivor
       rising to the centre, which is-centering still runs. */
    leaving.classList.remove('is-dominant');
    leaving.classList.remove('is-peek');
    if (swap) {
      /* THE DISPLACED CARD DOES NOT LEAVE. Nothing was dismissed, so
         it takes the pose the other card is rising out of and the
         greeting still has two cards in it. is-solo comes off with
         it: that class is the survivor's, and a card sharing the
         stack is never solo. */
      leaving.classList.remove('is-solo');
      leaving.classList.remove('is-centering');
      leaving.classList.add('is-peek');
    } else {
      leaving.classList.add('is-leaving');
      leaving.hidden = true;
    }

    /* ONLY A CARD THAT WAS PEEKING HAS SOMEWHERE TO RISE FROM. The
       keyframes start at the peek pose (dimmed, scaled back, 24px
       down) with fill both, so adding this to a card that is already
       dominant snapped the card the customer chose to KEEP down to
       72% and 94% for a frame and then eased it back: a visible
       flinch on the survivor, every time the LOWER card was closed. */
    var wasPeek = alive.classList.contains('is-peek');
    alive.classList.remove('is-peek');
    alive.classList.add('is-dominant');
    /* is-solo says "the only card on screen" and hands back every peek
       geometry. On the swap the partner is still there, so the promoted
       card is dominant and nothing more. */
    if (!swap) alive.classList.add('is-solo');
    if (wasPeek) {
      alive.classList.add('is-centering');
      setTimeout(
        guard(function () {
          alive.classList.remove('is-centering');
        }),
        PROMOTE_MS
      );
    }

    refs.host.setAttribute('data-greet-focus', otherKey === 'greet-hundred' ? 'hundred' : 'bundle');

    /* THE PROMOTED CARD ARRIVES UN-ARMED, exactly like a revealed one
       (round 14 fix). A promotion lifts a card the customer was NOT
       reading into the middle of the layer at full size, so its CTA
       lands under the same thumb that just tapped a 46px strip or a
       44px X. The second tap of a double tap, or a finger that has not
       yet come off the glass, would otherwise hit "Yes" on an offer
       nobody accepted. The component's founding law - a control that
       just moved into your coordinates does not act for ARM_MS -
       applies here for the same reason it applies at reveal(). The X
       stays live through the window, as always: see the swallow. */
    armWindow();

    pointLabel();
    /* The control that was just pressed is gone either way - the X
       with the card it hid, the strip button with the peek state it
       belonged to - so focus must move now or it drops to <body> and
       the next Tab restarts from the top of the document. The
       heading, for the reason stated at focusHeading(). */
    focusEl(alive.querySelector('.ryze-promo__title') || refs.dialog);
    syncFilms();
    return true;
  }

  function currentMessage() {
    return refs ? refs.host.getAttribute('data-message') || '' : '';
  }

  /* Every close path lands here, but they no longer all cost the same
     thing (R7, round 13 fix). kind is the caller's to name: the X and
     Escape both pass 1, a real dismissal that a cart change cannot
     touch; a backdrop tap passes 0, a machine quiet that
     the very next cart change lifts, because a stray tap on ~490px of
     dimmed page is not the sentence an X is. Either way SOMETHING is
     always stamped: without a quiet of some life, a box the customer
     just closed would be re-presented by the very next evaluate() and
     could not be got rid of at all.

     hard is Escape's flag: it forbids the greeting promotion so the
     first press closes the layer. Nothing else passes it. */
  function dismiss(key, kind, hard) {
    if (!refs) return;

    if (key === 'greet-bundle' || key === 'greet-hundred') {
      /* The partner card takes the centre and the box stays open, so
         this is not a close at all: no quiet, and no reload. A HARD
         close (Escape) skips the promotion entirely and falls through
         to the quiet plus hide() below, which spends the greet quiet
         at kind 1 and leaves the partner card untouched - unhidden,
         un-promoted, whole for whatever triggers the greeting next. */
      if (!hard && promoteGreet(key)) return;
      stampQuiet('greet', kind);
    } else if (key === 'menu') {
      /* data-message keeps the originating message while the menu is
         open, precisely so an X in the menu quiets the right one. */
      stampQuiet(currentMessage(), kind);
    } else if (QUIET_KEYS.indexOf(key) !== -1) {
      stampQuiet(key, kind);
    } else {
      stampQuiet(currentMessage(), kind);
    }

    hide();
    reloadIfDirty();
  }

  /* THE CART PAGE CORRECTS ITSELF ON CLOSE.
     The customer may add bottle after bottle out of the menu and the
     box stays open the whole time, which is the owner's ruling. What
     it cannot do is edit the cart page behind it: the line items, the
     totals, the discount lines and the free-delivery bar are all
     server rendered, and this file composes no figure and swaps no
     markup. So the page is reloaded the moment the customer is done
     with the box, and only then. One navigation, at the one moment
     nothing is on screen to interrupt.

     A section render was tried first and does not exist on this
     store: templates/cart.json registers the footer under the id
     `cart-footer`, so `?sections=main-cart-footer` renders a
     block-less footer with no `.js-contents` in it and
     `?section_id=cart-footer` 404s. Nothing to swap in, either way.

     The View cart link in the success panel needs none of this: it is
     a plain navigation and the page it lands on is freshly rendered. */
  function reloadIfDirty() {
    if (!cartDirty) return false;
    if (!onCartPage()) return false;
    cartDirty = false;
    try {
      window.location.reload();
    } catch (e) {
      return false;
    }
    return true;
  }

  /* WHICH CARD ESCAPE IS SPEAKING FOR: the one that currently holds
     focus, else the one the layer says is focused. Escape spends that
     card's message quiet at an X's kind, then closes the layer - it
     does not act as an X on the card (no promotion, see dismiss()). */
  function escapeKey() {
    if (!refs) return '';
    if (refs.host.getAttribute('data-view') === 'menu') return 'menu';
    var msg = currentMessage();
    if (msg !== 'greet') return msg;

    var active = document.activeElement;
    var card = active && typeof active.closest === 'function' ? active.closest('[data-promo-card]') : null;
    if (card && refs.host.contains(card)) return card.getAttribute('data-promo-card');
    return refs.host.getAttribute('data-greet-focus') === 'hundred' ? 'greet-hundred' : 'greet-bundle';
  }

  /* ─── Keyboard ────────────────────────────────────────────── */

  function focusables() {
    if (!refs) return [];
    /* The readonly quantity field is named EXPLICITLY. It is focusable
       by default and the browser puts it in the tab order between the
       two steppers, so leaving it to the [tabindex] clause meant it
       joined the trap only because something else happened to give it
       one. Named here, it participates by position, which is where a
       customer tabbing through a row expects to find it. type=hidden
       is excluded because it is not rendered, and [disabled] because a
       disabled field is not focusable. readonly is deliberately NOT
       excluded: a readonly input is still focusable and still holds
       the row's value. */
    var list = refs.dialog.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]),' +
        ' [tabindex]:not([tabindex="-1"]):not([data-promo-sentinel])'
    );
    return Array.prototype.filter.call(list, function (el) {
      /* offsetParent !== null is the whole trick: a hidden card and a
         hidden view drop out of the trap by themselves, so the trap
         always matches what is on screen with no bookkeeping. The
         close button is position:absolute inside a position:relative
         card, so its offsetParent is that card and it stays in. */
      if (el.offsetParent === null) return false;
      /* An inert subtree is rendered but refuses focus, so the
         browser skips it on Tab and el.focus() on anything inside it
         does nothing. Left in the list, the trap's own wrap-around
         would aim at a control that cannot take the focus and the
         customer would be stuck. */
      if (typeof el.closest === 'function' && el.closest('[inert]')) return false;
      return true;
    });
  }

  /* WRAPPED LIKE EVERY OTHER ENTRY POINT. It was the one listener
     attached raw, so a throw here reached the page instead of
     panic(): the scroll lock would never be released, the box never
     hidden, and every following Tab would throw again. The reference
     is stored, which is what removeEventListener needs. */
  var onKeydown = guard(function (e) {
    if (!isOpen || !refs) return;

    if (e.key === 'Escape' || e.keyCode === 27) {
      e.preventDefault();
      /* ONE ESCAPE, ONE CLOSE. This handler runs in the CAPTURE phase,
         and other RYZE components bind document-scoped Escape on the
         bubble phase (ryze-custom.js closes the search bar there). A
         modal layer owns the key while it is open: without this line
         one press would close the promo AND whatever else happens to
         be listening behind it. uiBlocker keeps those two apart today,
         which makes this belt to its braces, not a substitute. */
      e.stopPropagation();
      /* THE HARD CLOSE (owner call 2026-08-20): kind 1, a real
         dismissal like an X, but the third argument forbids the
         greeting promotion so this ONE press closes the layer even
         with both greet cards alive. */
      dismiss(escapeKey(), 1, true);
      return;
    }

    if (e.key !== 'Tab' && e.keyCode !== 9) return;

    var f = focusables();
    if (!f.length) {
      e.preventDefault();
      focusEl(refs.dialog);
      return;
    }

    var first = f[0];
    var last = f[f.length - 1];
    var active = document.activeElement;

    if (!refs.dialog.contains(active)) {
      e.preventDefault();
      focusEl(first);
    } else if (e.shiftKey && active === first) {
      e.preventDefault();
      focusEl(last);
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      focusEl(first);
    }
  });

  /* ─── The CTA delivery ───────────────────────────────────── */

  function onTargetClick(a, ev) {
    var target = a.getAttribute('data-promo-target');
    var el = target ? document.getElementById(target) : null;

    /* The customer said yes. Quiet the message so the same card is
       not thrown back over the section they were just delivered to.
       Kind 0, a machine quiet: an accept changes the cart state that
       armed the message, so the discriminator retires it on its own
       and the next cart change reading that back is exactly correct,
       never a re-arm of something still owed. */
    stampQuiet(currentMessage(), 0);

    /* "Am I on the page that holds the target" is answered by
       whether the element exists, not by sniffing the URL. When it
       does not exist the click is left alone and the browser follows
       the href, which is the shop root plus the hash. */
    if (!el) {
      hide();
      return;
    }

    ev.preventDefault();

    /* true = do not restore focus. This path is a DELIVERY, not a
       dismissal: sending focus back up the page would put the next
       Tab hundreds of pixels above the section the button just
       promised. */
    hide(true);

    /* An EXPLICIT behavior overrides the CSS scroll-behavior. This
       theme sets html:has(:target){scroll-behavior:smooth}
       (ryze-custom.css:146-154), so any #hash in the URL makes an
       implicit scroll animate unpredictably. */
    var reduce = reduceMotion();
    try {
      el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    } catch (e) {
      el.scrollIntoView(true);
    }

    /* Moving the viewport is not arriving. preventDefault threw away
       what a plain in-page link gives for free, so it is handed back
       here: focus is what a screen reader announces on arrival and
       what the next Tab continues from. */
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
    focusEl(el);
  }

  /* ─── THE MENU ───────────────────────────────────────────── */

  function rows() {
    return refs ? refs.host.querySelectorAll('[data-promo-row]') : [];
  }

  /* THE SIZE COMES FROM THE CTA THAT WAS PRESSED, as the value of its
     data-promo-menu-open. That is the whole difference between the
     pair cards' menu and the 100 ml menu that the greeting's 100 ml
     card and the `hundred` message both open: same card, same rows,
     same steppers, same add path, a different list of variants.
     Everything below this line is size agnostic. */
  function openMenu(size) {
    if (!refs || !refs.menu) return;

    var want = size === '100' ? '100' : '50';
    /* A size with no qualifying product ships no list, and its card's
       CTA is then an <a> rather than this button, so this is a guard
       against a hand-edited DOM and not a fallback path. Opening a
       menu with nothing in it is worse than not opening one. */
    if (!refs.lists[want]) return;

    /* Written BEFORE the view flips: the stylesheet picks the head,
       the success panel and the row list off this attribute, and
       pointLabel() reads it a few lines down. */
    refs.host.setAttribute('data-menu-size', want);
    /* data-message is NOT cleared: the menu shows regardless of
       origin, and the origin stays available for the quiet stamp. */
    refs.host.setAttribute('data-view', 'menu');
    setStatus('');
    syncRows();
    syncSteppersAll();
    syncFilms();
    pointLabel();
    focusEl(cardTitle(refs.menu) || refs.dialog);
  }

  /* The row thumbnails are lazy AND inside a display:none subtree,
     so the browser will not fetch them until the menu is on screen,
     which would pop five images in one frame under the customer's
     thumb. Per the HTML spec, moving `loading` away from "lazy"
     resumes the fetch at once, so they are in hand by the time the
     CTA is pressed. Nobody who never sees a message pays for them. */
  function primeRows() {
    if (!refs) return;
    each(refs.host.querySelectorAll('[data-promo-row] img'), function (img) {
      if (img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
    });
  }

  /* Visibility only, and one attribute. The tag was rendered on
     every row by Liquid; no node is ever created and no string is
     ever written. */
  function markRow(id, isIn) {
    if (!refs) return;
    var row = refs.host.querySelector('[data-promo-row][data-row-variant-id="' + id + '"]');
    if (!row) return;
    var tag = row.querySelector('[data-promo-row-tag]');
    if (tag) tag.hidden = !isIn;
  }

  function syncRows() {
    each(rows(), function (row) {
      var id = Number(row.getAttribute('data-row-variant-id'));
      markRow(id, cartIds[id] === 1);
    });
  }

  /* Bounds live in data-min / data-max because min / max are
     meaningless on a text input, and the field is type=text +
     inputmode=numeric because a readonly number input still paints
     native spin buttons that then do nothing. */
  function clampQty(input) {
    var min = parseInt(input.getAttribute('data-min'), 10);
    var max = parseInt(input.getAttribute('data-max'), 10);
    if (!isFinite(min)) min = 1;
    if (!isFinite(max)) max = 9;

    var n = parseInt(input.value, 10);
    if (!isFinite(n)) n = min;
    if (n < min) n = min;
    if (n > max) n = max;

    input.value = String(n);
    return { value: n, min: min, max: max };
  }

  /* The minus is inert at the floor and the plus at the ceiling, so
     the stepper can never produce a value the input would then have
     to correct. Inert, not disabled: the edge button is very often
     the one the customer is standing on. */
  function syncSteppers(row) {
    var input = row.querySelector('[data-promo-qty]');
    if (!input) return;

    var state = clampQty(input);

    /* A sold-out row was disabled by Liquid because the variant
       cannot be bought, and that is not this script's to undo. Under
       the EG-only geo gate that is every row seen from abroad. */
    if (row.classList.contains('is-unavailable')) return;

    each(row.querySelectorAll('[data-promo-step]'), function (btn) {
      var delta = Number(btn.getAttribute('data-promo-step'));
      var atEdge = delta < 0 ? state.value <= state.min : state.value >= state.max;
      /* The minus ships from Liquid with the REAL disabled
         attribute, because a row opens at the floor and that is the
         correct no-JS state. This first sync hands it over to
         aria-disabled, after which nothing here ever touches the
         property again. */
      btn.removeAttribute('disabled');
      if (atEdge) btn.setAttribute('aria-disabled', 'true');
      else btn.removeAttribute('aria-disabled');
    });
  }

  function syncSteppersAll() {
    each(rows(), function (row) {
      syncSteppers(row);
    });
  }

  /* textContent, never innerHTML, and the element was rendered by
     Liquid with an explicit display: a live region that is
     display:none while empty announces nothing when it is filled. */
  function setStatus(text) {
    if (!refs || !refs.status) return;
    refs.status.textContent = text || '';
  }

  /* THE SECOND LIVE REGION, and the only one that is invisible.
     .ryze-promo__status is a VISIBLE line and belongs to failures, so
     it cannot carry the two things that were announced to nobody: the
     quantity a stepper just produced, and a repeat add.

     The quantity: aria-live on the readonly <input> never fired at
     all. Setting .value changes an IDL property, it inserts no node
     and changes no character data, and a text control exposes no text
     subtree, so there is nothing for a live region to observe. Three
     presses moved the number from 1 to 4 in silence.

     The repeat add: the FIRST success announces because focus moves
     to the morphed heading. The second deliberately does not move
     focus, which left success and failure indistinguishable by ear
     from the second bottle onward, because only failure wrote to a
     live region.

     Announcing means writing a CHANGED string, so a repeated value is
     cleared first: an identical textContent is not a mutation. */
  function announce(text) {
    if (!refs || !refs.live) return;
    var next = text || '';
    if (refs.live.textContent === next) refs.live.textContent = '';
    refs.live.textContent = next;
  }

  /* Only wording this file raised, or Shopify's own description,
     reaches a customer. Everything else is browser internals and
     gets the owner's sentence from the schema. */
  function houseError() {
    var t = refs && refs.status ? refs.status.getAttribute('data-promo-status') : '';
    return t || 'Something went wrong. Please try again.';
  }

  function setMenuBusy(busy, btn) {
    if (!refs) return;

    each(refs.host.querySelectorAll('[data-promo-add], [data-promo-step]'), function (b) {
      /* A sold-out control carries the REAL disabled attribute,
         server rendered and permanent. Everything else goes
         aria-disabled for the duration, so a second press cannot
         start a second request while the control keeps its focus and
         its place in the tab order. */
      if (b.hasAttribute('disabled')) return;
      if (busy) b.setAttribute('aria-disabled', 'true');
      else b.removeAttribute('aria-disabled');
    });

    each(refs.host.querySelectorAll('[data-promo-qty]'), function (i) {
      /* The field is readonly by contract, the steppers being the
         only way to change it, so busy adds aria-disabled and
         nothing else. Never the disabled property on a control that
         may be holding focus. */
      i.readOnly = true;
      if (busy) i.setAttribute('aria-disabled', 'true');
      else i.removeAttribute('aria-disabled');
    });

    if (refs.menu) {
      if (busy) refs.menu.classList.add('is-busy');
      else refs.menu.classList.remove('is-busy');
    }

    if (busy) {
      if (btn) btn.classList.add('is-busy');
    } else {
      /* EVERY spinner, not just this request's button. The one that
         was actually pressed is not always the one still turning: a
         request whose showing was replaced left its own button
         spinning on a card composed for another message, and the
         customer had no way to stop it. */
      each(refs.host.querySelectorAll('[data-promo-add].is-busy'), function (b) {
        b.classList.remove('is-busy');
      });
      if (btn) btn.classList.remove('is-busy');
      syncSteppersAll();
    }
  }

  /* The busy state, released together with the claim on it. Bumping
     the token is what makes this safe to call from anywhere: a
     request still in flight loses ownership and can no longer write
     the busy state of whatever replaced its box. */
  function clearBusy() {
    addToken++;
    menuBusy = false;
    /* CODE-06 (2026-10-18): queued taps die with the claim. They used to
       survive a hide or a failed read and ride out on the NEXT add, as a
       bottle nobody asked for any more. */
    menuAddQueue.length = 0;
    setMenuBusy(false, null);
  }

  function updateHeaderBadge(cart) {
    each(document.querySelectorAll('.ryze-nav__cart-count'), function (b) {
      b.textContent = cart.item_count;
      b.style.display = cart.item_count > 0 ? 'flex' : 'none';
      /* Bump ONLY on a real count change, and NEVER during the first second
         after boot: navigations write every badge fresh (the marker starts
         empty on a new page), and those load-time writes must initialise
         silently. The boot anchor is shared: whichever script writes first
         plants it, so all writers count from the same moment. */
      window.__ryzeBadgeBoot = window.__ryzeBadgeBoot || Date.now();
      var ryzeBadgeMoved = b.dataset.ryzeLastCount !== String(b.textContent);
      b.dataset.ryzeLastCount = String(b.textContent);
      if (ryzeBadgeMoved && Date.now() - window.__ryzeBadgeBoot > 1000) {
        b.classList.remove('ryze-badge-bump');
        void b.offsetWidth;
        b.classList.add('ryze-badge-bump');
      }
    });
  }

  /* THE CART PAGE'S TOTALS ARE NOT PATCHED FROM HERE.
     A section render was built first and is dead on this store:
     templates/cart.json registers the footer under the id
     `cart-footer`, so `?section_id=cart-footer` 404s and
     `?sections=main-cart-footer` renders a block-less footer with no
     `.js-contents` inside it. There is nothing to swap in.

     What replaced it is cartDirty plus reloadIfDirty(): the add marks
     the page stale, the box stays open for as many more bottles as
     the customer wants, and the close reloads. One navigation, at the
     moment nothing is on screen to interrupt. */

  /* SCOPED TO THE BOX THAT IS ACTUALLY ON SCREEN. Nothing here is
     cheap to get wrong: it un-hides the success panel, morphs the
     menu head and, the first time, takes the focus. Run against a
     box the customer has already closed it pulled focus into a
     dialog mid-fade and the browser then dropped it to <body> when
     hidden landed; run against a box recomposed for another message
     it left "Added to your bag" sitting over a picker the customer
     had added nothing in. The add's cart-side work is unaffected:
     that half runs whatever happened to the box. */
  function showSuccess() {
    if (!refs || !refs.menu) return;
    if (!isOpen) return;

    /* The panel belonging to the size that is open. The other one
       stays hidden, so the card can never confirm a 100 ml over the
       50 ml list or the other way round. */
    var success = refs.successes[menuSize()];
    if (!success) return;

    var firstTime = !refs.menu.classList.contains('is-success');

    /* A strict two-step, because [hidden] is display:none !important
       inside this component and cannot be transitioned. The forced
       reflow gives the transition two frames to run between. */
    success.hidden = false;
    void refs.menu.offsetWidth;
    refs.menu.classList.add('is-success');

    /* The header morph is the confirmation, so on the FIRST success
       focus moves to it: that is what makes a screen reader announce
       the result at all. On a repeat add it stays where it is,
       because the menu deliberately stays open for exactly that and
       yanking focus back to the header on every tap would fight the
       customer who is adding a second bottle. */
    var heading = success.querySelector('.ryze-promo__title');
    if (firstTime) {
      pointLabel();
      focusEl(heading || refs.dialog);
    } else {
      /* Focus stays put, so the announcement has to come from a live
         region instead. The owner's own success heading, read out of
         the DOM: no copy is composed here. */
      announce(heading ? heading.textContent : '');
    }
  }

  /* ─── The add ────────────────────────────────────────────────
     Trust model, unchanged from ryze-100ml-offer.js:

       1  No price is read, computed or transmitted. /cart/add.js is
          sent a numeric variant id Liquid rendered and an integer.
       2  The STATUS decides the outcome, never the parse. A body
          that will not parse becomes null instead of a rejection
          carrying the browser's own wording.
       3  Only an error THIS file raised may be quoted, which is what
          the ryzeSafe flag is for. The geo gate's 422 arrives with
          Shopify's own description and is treated as an ordinary
          failed add: the row shows its error state and nothing
          loops.
       4  The add and everything after it are separate outcomes. Past
          a 2xx the bottle IS in the cart, and no later failure may
          be reported as a failed add: that is how a customer buys
          the same bottle twice.
       5  Transient unavailability is aria-disabled, never the
          disabled property, because one of these buttons is the one
          holding focus.

     ONE payload entry per variant, carrying the summed quantity.
     Repeated { quantity: 1 } entries for the same id are what the
     bundle builder does and they are not correct here. */

  function menuDrainNext() {
    if (!refs || !isOpen) { menuAddQueue.length = 0; return; }
    /* CODE-13: an add is in flight (a direct tap slipped in after the last
       release); its own success drains the queue. Never drop the taps. */
    if (menuBusy) return;
    var next = menuAddQueue.shift();
    if (!next) return;
    /* coalesce every queued tap of this variant into ONE quantity */
    var total = next.qty;
    var rest = [];
    for (var qi = 0; qi < menuAddQueue.length; qi++) {
      if (menuAddQueue[qi].id === next.id) total += menuAddQueue[qi].qty;
      else rest.push(menuAddQueue[qi]);
    }
    menuAddQueue = rest;
    /* CODE-06: only the size list on show; the hidden list carries buttons
       for other variants and a stale match could add the wrong bottle. */
    var shownList = (refs.lists && refs.lists[menuSize()]) || refs.host;
    var nextBtn = shownList.querySelector('[data-promo-add][data-variant-id="' + next.id + '"]');
    if (!nextBtn || nextBtn.disabled) { menuDrainNext(); return; }
    rowAdd(nextBtn, total);
  }

  function rowAdd(btn, forcedQty) {
    if (!refs) return;
    if (menuBusy) {
      /* THE RAGE QUEUE: the tap counts, it just waits its turn. The
         busy aria-disabled is bypassed on purpose - a rage tap is not
         a disabled control, it is the next order. Sold-out buttons
         carry the real disabled attribute and never fire a click. */
      var qId = Number(btn.getAttribute('data-variant-id'));
      if (isFinite(qId) && qId > 0) {
        var qRow = typeof btn.closest === 'function' ? btn.closest('[data-promo-row]') : null;
        var qInput = qRow ? qRow.querySelector('[data-promo-qty]') : null;
        menuAddQueue.push({ id: qId, qty: qInput ? clampQty(qInput).value : 1 });
      }
      return;
    }
    if (isInert(btn)) return;

    var id = Number(btn.getAttribute('data-variant-id'));
    if (!isFinite(id) || id <= 0) return;

    var row = typeof btn.closest === 'function' ? btn.closest('[data-promo-row]') : null;
    var input = row ? row.querySelector('[data-promo-qty]') : null;
    var qty = forcedQty || (input ? clampQty(input).value : 1);

    /* This request's claim on the busy state, and the showing it was
       started from. Both are checked before anything is written. */
    var myToken = ++addToken;
    var myShowing = showingId;
    var ownsBusy = function () {
      return addToken === myToken;
    };
    var ownsBox = function () {
      return isOpen && showingId === myShowing;
    };

    menuBusy = true;
    setMenuBusy(true, btn);
    setStatus('');
    if (row) row.classList.remove('is-error');

    /* THE WATCHDOG, AND WHAT IT IS ALLOWED TO CONCLUDE.
       fetch has no timeout of its own: a request that never settles
       would leave menuBusy true and every control aria-disabled for
       the rest of the page, with a spinner turning and nothing to
       explain it. So after ADD_TIMEOUT_MS the controls come back.

       WHAT IT MUST NOT DO IS CALL THE ADD FAILED. Twelve seconds of
       silence on a congested mobile link is not evidence of failure,
       and this store is EG-only with a real round trip: the request
       is very often still alive. Telling the customer it failed and
       handing back a live Add button is precisely how they press it
       again and buy two of the same bottle, which trust rule 4 above
       exists to forbid. Expiry therefore releases the controls,
       re-reads /cart.js so the row tags and the badge describe the
       real cart before the row can be pressed again, and says
       nothing. If the add did land, the row reads "In your bag"; if
       it did not, the row is simply available again.

       `settled` is only about who may report an OUTCOME, and the
       watchdog no longer claims one, so a late response still runs
       its own success or failure branch in full. */
    var settled = false;
    var timedOut = false;
    var watchdog = setTimeout(
      guard(function () {
        if (settled || timedOut) return;
        timedOut = true;
        if (ownsBusy()) {
          menuBusy = false;
          setMenuBusy(false, btn);
        }
        /* an unknown outcome may not be machine-gunned */
        menuAddQueue.length = 0;
        /* Cart truth, not a verdict. Silent on failure, as everywhere
           else a read is best effort. */
        readCart()
          .then(
            guard(function (cart) {
              if (!cart) return;
              counts(cart);
              syncRows();
              updateHeaderBadge(cart);
              evaluate();
            })
          )
          ['catch'](noop);
      }),
      ADD_TIMEOUT_MS
    );

    fetch(routeRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    })
      .then(function (res) {
        return res
          .json()
          ['catch'](function () {
            return null;
          })
          .then(function (body) {
            if (!res.ok) {
              throw safeError(body && body.description ? body.description : houseError());
            }
            return body;
          });
      })
      .then(
        guard(function () {
          /* Past this line the add SUCCEEDED and the bottle is in the
             cart. Everything below is presentation and none of it may
             be reported as a failed add. */
          if (settled) return null;
          settled = true;
          clearTimeout(watchdog);

          if (ownsBusy()) {
            menuBusy = false;
            setMenuBusy(false, btn);
          }
          /* CODE-06: the rage queue takes its turn the moment the add is
             confirmed, never behind the best-effort cart read (a 429 there
             used to strand the queue for a later, unrelated add). */
          menuDrainNext();

          /* THE BOX HALF, only while it is still this box. The cart
             half below always runs: the badge, the publish and the
             re-evaluate are true whatever became of the card. */
          if (ownsBox()) {
            markRow(id, true);
            if (row) {
              row.classList.add('is-added');
              setTimeout(
                guard(function () {
                  row.classList.remove('is-added');
                }),
                ROW_OK_MS
              );
            }
            showSuccess();
          }

          /* The cart page is now stale behind the box, and it stays
             stale on purpose: the menu is deliberately left open for
             the next bottle. reloadIfDirty() spends this on close.
             Set before the cart read below, because it does not need
             the cart and must not depend on it.

             IF THE BOX HAS ALREADY GONE, IT IS SPENT NOW. The close
             is live during an add by contract (the rows block no
             pointer events), so a customer who taps Add and then X
             inside the response window used to run reloadIfDirty()
             on a flag that was set a moment later, and stood on a
             cart page listing three bottles under a total for two. */
          if (onCartPage()) {
            cartDirty = true;
            if (!isOpen) reloadIfDirty();
          }

          /* Best effort from here down. A read that fails resolves to
             null and the add stays a success. */
          return readCart()['catch'](function () {
            return null;
          });
        })
      )
      .then(
        guard(function (cart) {
          if (!cart) return;

          /* Refreshes the id map behind the row tags. The state
             machine is not run from here: the publish below feeds
             evaluate(), which does its own fresh read, and running it
             twice for one cart would be two decisions from one fact. */
          counts(cart);
          syncRows();
          updateHeaderBadge(cart);

          /* The real /cart.js response, never the add response, which
             is not uniform across publishers on this theme. Both
             globals are bare, so both are guarded. Never publish {}. */
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ryze-promo', cartData: cart });
          }

          evaluate();
        })
      )
      ['catch'](
        guard(function (err) {
          if (settled) return;
          settled = true;
          clearTimeout(watchdog);
          var mine = ownsBusy();
          if (mine) {
            menuBusy = false;
            setMenuBusy(false, btn);
          }
          /* a failing endpoint may not be machine-gunned */
          menuAddQueue.length = 0;
          /* A real failure, so it IS reported, but only into the box
             it belongs to and only while it is still the last word.
             An error line written across a card the customer opened
             for another message describes nothing they did, and one
             written after they gave up and re-added successfully
             would contradict the confirmation in front of them. */
          if (!mine || !ownsBox()) return;
          if (row) row.classList.add('is-error');
          setStatus(err && err.ryzeSafe && err.message ? err.message : houseError());
        })
      );
  }

  /* ─── The films ──────────────────────────────────────────────
     Promoted only when the owner has them on, motion is not reduced,
     and the owning card is the one being read. A peeking greeting
     card holds its poster: two films decoding at once on a phone is
     the cost this rule exists to refuse. The loops are PALINDROMES
     encoded into the file, so a plain loop attribute is the whole
     mechanism. Never add a crossfade: on this drifting footage it
     visibly resizes the bottles, and that was built once and
     rejected. */

  function filmsAllowed() {
    return on('data-films') && !reduceMotion();
  }

  function startFilm(film) {
    if (film.__ryzePromoFilmDead) return;
    if (!film.getAttribute('src')) {
      var src = film.getAttribute('data-src');
      if (!src) return;
      film.setAttribute('src', src);
      film.load();
    }
    var p = film.play();
    /* Autoplay can be refused. The poster is already painted, so a
       refusal simply leaves the still and is not worth surfacing. */
    if (p && typeof p['catch'] === 'function') p['catch'](noop);
  }

  function stopFilm(film) {
    film.classList.remove('is-playing');
    try {
      if (!film.paused) film.pause();
    } catch (e) {
      /* a film that will not pause is not worth a thrown error */
    }
  }

  function syncFilms() {
    if (!refs) return;
    var allowed = filmsAllowed();
    eachCard(function (key, card) {
      var film = card.querySelector('[data-promo-film]');
      if (!film || film.tagName !== 'VIDEO') return;
      var want =
        isOpen &&
        allowed &&
        !document.hidden &&
        card.offsetParent !== null &&
        (card.classList.contains('is-dominant') || card.classList.contains('is-solo'));
      if (want) startFilm(film);
      else stopFilm(film);
    });
  }

  function stopFilms() {
    if (!refs) return;
    eachCard(function (key, card) {
      var film = card.querySelector('[data-promo-film]');
      if (film && film.tagName === 'VIDEO') stopFilm(film);
    });
  }

  /* ─── The pill ───────────────────────────────────────────────
     A live region that must NEVER be display:none, hidden or
     visibility:hidden, in any state: a region that is not rendered
     announces nothing. It is hidden visually with transform and
     opacity alone, and its text is set at show time and cleared
     after the exit, which is what makes the announcement fire. */

  function pillMessage() {
    if (!refs || !refs.pillText) return '';
    var fromAttr = refs.pillText.getAttribute('data-promo-pill-text');
    if (fromAttr) return fromAttr;
    return pillCopy;
  }

  function showPill(attempt) {
    if (!refs || !refs.pill || !refs.pillText) {
      pillArmed = false;
      return;
    }

    if (!on('data-pill-enabled')) {
      pillArmed = false;
      return;
    }

    /* THE PILL NEVER RISES BEHIND AN OPEN BOX. It sits at 1090 and
       this layer at 1100, so a pill raised while a card is on screen
       spends its whole life under the scrim: the one thing it exists
       to confirm is the one thing that cannot be read. The open box
       is itself the acknowledgment, so the transition is SPENT here
       rather than queued. Queued is wrong on purpose: it would raise
       the pill minutes later, after a close, over a cart the
       customer has moved on from.

       THE ANNOUNCEMENT IS KEPT. A screen reader customer gets
       nothing from a card they cannot see, and this region is
       rendered in every state (opacity and transform only), so
       writing its text announces without painting a pixel. It is
       cleared on the same clock a visible pill runs on, which is
       what keeps a later identical pill a CHANGE to the region
       rather than a repeat that says nothing.

       pillUntil is set exactly as a shown pill sets it, so
       presentDelay() spaces the follow-up bundle card by the same
       interval whether the pill was seen or skipped: the
       choreography is unchanged. */
    if (isOpen) {
      pillArmed = false;
      clearTimeout(pillWaitTimer);
      clearTimeout(pillTimer);

      var quiet = pillMessage();
      if (!quiet) return;

      refs.pillText.textContent = quiet;
      var quietLife = pillMs();
      pillUntil = Date.now() + quietLife;
      pillTimer = setTimeout(
        guard(function () {
          if (!refs || !refs.pill || !refs.pillText) return;
          /* A real pill that started in the meantime owns the region
             and its own hidePill() will clear it. */
          if (refs.pill.classList.contains('is-open')) return;
          refs.pillText.textContent = '';
        }),
        quietLife
      );
      return;
    }

    /* The cart toast owns its moment and sits far above this layer.
       Queue behind it, and behind a hidden tab, and retry: a hidden
       tab runs no rendering steps, so a pill shown there would rise
       and fall without ever being painted. The same wait covers a
       sheet not yet applied (CODE-19): the inline rest rule keeps
       that pill invisible, so its life would run out unseen. */
    var wait = document.visibilityState !== 'visible' || document.querySelector('.ryze-ctoast.ryze-ctoast--in') || !stylesReady();
    if (wait) {
      var next = num(attempt) + 1;
      if (next > PILL_RETRY_MAX) {
        pillArmed = false;
        return;
      }
      clearTimeout(pillWaitTimer);
      pillWaitTimer = setTimeout(
        guard(function () {
          showPill(next);
        }),
        QUEUE_MS
      );
      return;
    }

    pillArmed = false;
    clearTimeout(pillWaitTimer);
    clearTimeout(pillTimer);

    var text = pillMessage();
    if (!text) return;

    refs.pill.classList.remove('is-leaving');
    refs.pillText.textContent = text;
    void refs.pill.offsetWidth;
    refs.pill.classList.add('is-open');

    var life = pillMs();
    pillUntil = Date.now() + life;

    pillTimer = setTimeout(
      guard(function () {
        hidePill();
      }),
      life
    );
  }

  function hidePill() {
    if (!refs || !refs.pill) return;
    refs.pill.classList.add('is-leaving');
    refs.pill.classList.remove('is-open');
    setTimeout(
      guard(function () {
        if (!refs || !refs.pill) return;
        if (refs.pill.classList.contains('is-open')) return;
        refs.pill.classList.remove('is-leaving');
        if (refs.pillText) refs.pillText.textContent = '';
      }),
      EXIT_MS
    );
  }

  /* ─── Binding ────────────────────────────────────────────────
     Only the FIRST instance is ever bound. There are no presets and
     the schema sets "limit": 1, so a second one should not exist; if
     it ever does it stays inert rather than fighting the first. */

  function resolvePillCopy() {
    if (!refs || !refs.pillText) return;
    if (refs.pillText.getAttribute('data-promo-pill-text')) {
      /* The sentence rides on the attribute. The span is already
         empty, which is what the live region needs. */
      refs.pillText.textContent = '';
      return;
    }
    var t = (refs.pillText.textContent || '').replace(/^\s+|\s+$/g, '');
    if (t) pillCopy = t;
    /* Emptied so the first show is a CHANGE to the live region.
       Text present at parse time in a region is not announced. */
    refs.pillText.textContent = '';
  }

  function resolve() {
    var host = document.querySelector('[data-ryze-promo]');
    if (!host) {
      refs = null;
      return false;
    }
    if (refs && refs.host === host) return true;

    var dialog = host.querySelector('[data-promo-dialog]');
    if (!dialog) {
      refs = null;
      return false;
    }

    refs = {
      host: host,
      dialog: dialog,
      stack: host.querySelector('[data-promo-stack]'),
      cards: {},
      menu: null,
      /* THE MENU IS RENDERED PER SIZE: a head, a success panel and a
         row list for the 50 ml and for the 100 ml, keyed by the
         data-promo-size Liquid wrote on each. A single querySelector
         would always return the 50 ml one, which is precisely the bug
         these three maps exist to make impossible. The X, the status
         line and the announcer are shared and stay single refs. */
      heads: {},
      successes: {},
      lists: {},
      status: host.querySelector('[data-promo-status]'),
      /* The invisible announcer. See announce(). */
      live: host.querySelector('[data-promo-live]'),
      /* The pill and the return sentinel live OUTSIDE the host: the
         host carries hidden when closed, and focus cannot be
         delivered into a hidden subtree. */
      pill: document.querySelector('[data-ryze-promo-pill]'),
      pillText: null,
      ret: document.querySelector('[data-promo-return]')
    };

    each(host.querySelectorAll('[data-promo-card]'), function (card) {
      refs.cards[card.getAttribute('data-promo-card')] = card;
    });
    each(host.querySelectorAll('[data-promo-menu-head]'), function (el) {
      refs.heads[sizeOf(el)] = el;
    });
    each(host.querySelectorAll('[data-promo-success]'), function (el) {
      refs.successes[sizeOf(el)] = el;
    });
    each(host.querySelectorAll('[data-promo-menu-list]'), function (el) {
      refs.lists[sizeOf(el)] = el;
    });
    refs.menu = refs.cards.menu || null;
    if (refs.pill) refs.pillText = refs.pill.querySelector('[data-promo-pill-text]');

    if (host.getAttribute('data-promo-ready') !== '1') {
      host.setAttribute('data-promo-ready', '1');
      bind(host);
      resolvePillCopy();
      syncSteppersAll();
    }

    return true;
  }

  /* THE ARM, read from the DOM rather than kept in a second variable:
     reveal() writes the class, hide() takes it off, and the state
     snapshot already reports it from there. One source, no drift. */
  function armed() {
    return !!(refs && refs.host.classList.contains('is-armed'));
  }

  function bind(host) {
    /* ONE delegated click listener for the whole component, so five
       rows plus four cards cost one binding. An aria-disabled control
       still receives clicks, which is the entire point of using it,
       so every refusal lives inside the handler, exactly as it does
       in Dawn's own product-form.js. */
    host.addEventListener(
      'click',
      guard(function (ev) {
        /* THE SWALLOW (owner order 2026-08-20). Until is-armed lands
           the layer absorbs the tap and acts on none of it: the CTA
           does not fire, the backdrop does not dismiss, no quiet of
           any kind is stamped, and the message stays exactly where it
           is. The tap dies HERE rather than passing through to the
           page, which is what the stylesheet's old pointer-events
           trick allowed and what the owner ruled out: a customer who
           deliberately tapped the card that just appeared must not
           silently navigate the page underneath it.

           preventDefault kills the default of anything the tap did
           reach (the success panel's View cart anchor is the one real
           href in here), and stopPropagation keeps the swallowed
           event away from the document-level listeners other RYZE
           components attach. The close X is the sole exception and is
           tested for FIRST, because a layer that appears unbidden may
           never refuse to be closed. */
        if (!armed()) {
          var live =
            ev.target && typeof ev.target.closest === 'function' ? ev.target.closest('[data-promo-dismiss]') : null;
          if (!live || !host.contains(live)) {
            ev.preventDefault();
            ev.stopPropagation();
            return;
          }
        }

        /* THE BACKDROP IS EVERYTHING THAT IS NOT A CARD. The scrim is
           a pseudo-element, so a click above or below a card does
           land on the host itself, but the dialog is a real element
           at width 100% and the stack is a real grid: a click to the
           LEFT or RIGHT of a card lands on one of those instead, and
           on a 1440 desktop that is roughly 490px of dimmed page on
           each side that did nothing. Backdrop-to-close now works
           from all four sides, which is what it always claimed. */
        if (!ev.target) return;

        if (
          ev.target === host ||
          (typeof ev.target.hasAttribute === 'function' &&
            (ev.target.hasAttribute('data-promo-dialog') || ev.target.hasAttribute('data-promo-stack')))
        ) {
          /* A scrim tap is not a sentence: kind 0, a machine quiet
             that the next cart change lifts.

             THE KEY IS RESOLVED ONCE, HERE. Passing 'menu' sent
             dismiss() back to data-message for a SECOND read, and an
             empty one reached stampQuiet(''), which is a silent no-op:
             the box the customer had just tapped away could be
             re-presented by the very next evaluate() and could not be
             got rid of at all. A resolved quiet key cannot do that, and
             the greeting is the floor because it is the one message
             that can be on screen before any cart fact exists. */
          var scrim = currentMessage();
          dismiss(QUIET_KEYS.indexOf(scrim) === -1 ? 'greet' : scrim, 0);
          return;
        }

        if (typeof ev.target.closest !== 'function') return;

        var x = ev.target.closest('[data-promo-dismiss]');
        if (x && host.contains(x)) {
          ev.preventDefault();
          /* The close X: kind 1, a real dismissal. */
          dismiss(x.getAttribute('data-promo-dismiss'), 1);
          return;
        }

        /* THE PEEK STRIP PROMOTES (owner order 2026-08-20). Tested
           after the X, which lives in the same strip and keeps its
           dismiss meaning. The attribute's VALUE is the card asking
           to come forward, so the card being displaced is the one
           promoteGreet() is told about, with swap set: it demotes to
           the peek pose instead of leaving. Nothing is stamped and
           nothing closes - a promotion is not a decision about the
           offer, only about which offer is being read. */
        var up = ev.target.closest('[data-promo-promote]');
        if (up && host.contains(up)) {
          ev.preventDefault();
          /* Handled HERE and nowhere else, symmetrically with the
             swallow: a strip tap is an instruction to this layer about
             which card it is showing, and no document-level listener
             another RYZE component attached has any business reading
             it. */
          ev.stopPropagation();
          var upKey = up.getAttribute('data-promo-promote');
          var downKey = upKey === 'greet-bundle' ? 'greet-hundred' : 'greet-bundle';
          promoteGreet(downKey, true);
          return;
        }

        /* The success panel's View cart is a plain <a href> and is
           deliberately left alone: the browser navigates and the box
           goes with the page. */
        if (ev.target.closest('[data-promo-viewcart]')) return;

        /* The attribute's VALUE is the size to open: "50" from the
           three pair cards, "100" from either 100 ml card, the
           greeting's or the `hundred` message's. */
        var open = ev.target.closest('[data-promo-menu-open]');
        if (open && host.contains(open)) {
          ev.preventDefault();
          openMenu(open.getAttribute('data-promo-menu-open'));
          return;
        }

        var target = ev.target.closest('[data-promo-target]');
        if (target && host.contains(target)) {
          onTargetClick(target, ev);
          return;
        }

        var step = ev.target.closest('[data-promo-step]');
        if (step && host.contains(step)) {
          ev.preventDefault();
          if (isInert(step)) return;
          var row = step.closest('[data-promo-row]');
          if (!row) return;
          var input = row.querySelector('[data-promo-qty]');
          if (!input) return;
          var delta = Number(step.getAttribute('data-promo-step')) || 0;
          input.value = String((parseInt(input.value, 10) || 1) + delta);
          /* A failure tint is answered by the next interaction with
             that row, which this is. */
          row.classList.remove('is-error');
          syncSteppers(row);
          /* The new value, out loud. The field's own aria-live never
             fired: .value writes no node and no character data.
             Named with the row's own visually-hidden label, which is
             Shopify's "Quantity for <product>" translation, so no
             copy is composed here. */
          var qtyLabel = row.querySelector('.ryze-promo__qty label');
          var qtyName = qtyLabel ? String(qtyLabel.textContent).replace(/^\s+|\s+$/g, '') : '';
          announce(qtyName ? qtyName + ' ' + input.value : input.value);
          return;
        }

        var add = ev.target.closest('[data-promo-add]');
        if (add && host.contains(add)) {
          ev.preventDefault();
          rowAdd(add);
        }
      })
    );

    /* The two focus sentinels catch focus arriving from browser
       chrome or a screen-reader rotor, which the keydown trap cannot
       see. They are <span> on purpose: span is not on the base.css
       :empty list, so an empty sentinel survives. */
    each(host.querySelectorAll('[data-promo-sentinel]'), function (s) {
      s.addEventListener(
        'focus',
        guard(function () {
          if (!isOpen) return;
          var f = focusables();
          if (!f.length) {
            focusEl(refs.dialog);
            return;
          }
          focusEl(s.getAttribute('data-promo-sentinel') === 'start' ? f[f.length - 1] : f[0]);
        })
      );
    });

    each(host.querySelectorAll('[data-promo-film]'), function (film) {
      if (film.tagName !== 'VIDEO') return;
      film.addEventListener(
        'playing',
        guard(function () {
          film.classList.add('is-playing');
        })
      );
      film.addEventListener(
        'pause',
        guard(function () {
          film.classList.remove('is-playing');
        })
      );
      /* If the file cannot be decoded, return the element to its
         pre-play state: no source, poster showing, never an empty
         box. It cannot re-enter, because the dead flag stays set. */
      film.addEventListener(
        'error',
        guard(function () {
          film.__ryzePromoFilmDead = true;
          film.classList.remove('is-playing');
          film.removeAttribute('src');
          film.load();
        })
      );
    });
  }

  /* Trigger 3, and the one that carries the store: the wishlist
     shim rewrites this badge after every cart mutation, whatever
     path made it. */
  function watchBadge() {
    if (typeof MutationObserver !== 'function') return true;
    var badges = document.querySelectorAll('.ryze-nav__cart-count');
    if (!badges.length) return false;

    each(badges, function (b) {
      if (observed && observed.has(b)) return;
      if (observed) observed.add(b);
      new MutationObserver(
        guard(function () {
          evaluate();
        })
      ).observe(b, { childList: true, characterData: true, subtree: true });
    });
    return true;
  }

  function watchBadgeWithRetry(attempt) {
    if (watchBadge()) return;
    if (attempt >= 10) return;
    setTimeout(
      guard(function () {
        watchBadgeWithRetry(attempt + 1);
      }),
      500
    );
  }

  /* THE COURTESY HOLD's sensor. Capture phase and passive, so it
     cannot cancel, delay or otherwise touch a gesture the page is
     handling: it only writes a number. pointerdown is filtered to
     touch and pen because a mouse cannot suffer tap theft and a
     desktop customer moving a cursor should not be able to hold the
     component off indefinitely. touchstart is kept alongside for
     browsers with no pointer events (older iOS Safari). Both write
     the same clock, so a browser firing both is not double-counted. */
  function watchTouch() {
    /* Nothing is ever revealed in a quiet room, so the hold it feeds
       has nothing to defer: the same gate warmGreet() takes, for the
       same reason. Two document listeners on every cart and checkout
       page, writing a clock nobody reads, is work this component does
       not need to do. */
    if (quietRoom()) return;
    var mark = guard(function (ev) {
      if (ev && ev.type === 'pointerdown' && ev.pointerType === 'mouse') return;
      lastTouchAt = Date.now();
    });
    var opts = false;
    try {
      /* Passive is asserted where it is understood and ignored where
         it is not; either way this listener never calls preventDefault. */
      opts = { passive: true, capture: true };
    } catch (e) {
      opts = true;
    }
    document.addEventListener('pointerdown', mark, opts);
    document.addEventListener('touchstart', mark, opts);
  }

  /* THE ARTWORK WARM-UP (Tier B / proposal 0c). The greeting's two
     stills ship with no src, so the old reveal began its download at
     present() and the customer met a decoding box mid-thumb. Warming
     them on idle makes the reveal instant art. It is deliberately
     narrow: only the greeting, only when the greeting is actually
     still armed for this visitor, only once per load, and never in a
     quiet room, so nobody downloads artwork for a card they will not
     be shown. loadArts() is the same path present() uses, which is
     the point — a warmed img is simply already complete when present()
     asks for it. */
  function warmGreet() {
    if (warmed || !refs) return;
    if (quietRoom()) return;
    if (!messageEnabled('greet')) return;
    if (greetSeenHere() || quietLeft('greet') > 0) return;
    warmed = true;
    loadArts(artsFor('greet'), noop);
  }

  function idle(fn) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(fn, { timeout: 2000 });
      return;
    }
    setTimeout(fn, 1200);
  }

  function kick() {
    if (kicked) return;
    kicked = true;
    setTimeout(guard(evaluate), LOAD_SETTLE_MS);
    /* Off the settle path on purpose: a slow or failing /cart.js read
       must not decide whether the artwork is ready. */
    idle(
      guard(function () {
        if (resolve()) warmGreet();
      })
    );
  }

  function init() {
    resolve();

    /* Trigger 1. Bare globals, so both are guarded. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      try {
        subscribe(
          PUB_SUB_EVENTS.cartUpdate,
          guard(function () {
            evaluate();
          })
        );
      } catch (e) {
        /* pubsub not usable here, the other three triggers cover it */
      }
    }

    /* Trigger 2. The bundle builder is the only publisher, and it
       publishes nothing else at all. */
    document.addEventListener(
      'ryze:cart:updated',
      guard(function () {
        evaluate();
      })
    );

    /* Trigger 3. */
    watchBadgeWithRetry(0);

    /* Not a trigger: THE COURTESY HOLD's sensor, which only ever
       defers a reveal and never causes one. */
    watchTouch();

    /* Trigger 4. */
    if (document.readyState === 'complete') kick();
    else window.addEventListener('load', guard(kick));

    /* BFCACHE. Back from /cart or /checkout on iOS Safari restores
       this document from memory: no load, no DOMContentLoaded, no new
       script execution. The per-load flags are per load by
       definition, so a restored page is a new load for them.

       A BOX STILL ON SCREEN IS CLOSED, NOT LEFT ALONE. It used to be
       the one case that returned early, and the DOM comes back
       exactly as it was frozen: the success panel still confirming a
       bottle the customer may have removed on the cart page they
       just came back from, the row tags still describing that older
       cart, and body.overflow-hidden still locking the scroll. No
       quiet is spent, because the customer dismissed nothing;
       hide() re-evaluates, so whatever the cart now deserves is
       scheduled from a fresh read. */
    window.addEventListener(
      'pageshow',
      guard(function (ev) {
        if (!ev || !ev.persisted) return;
        if (isOpen) hide();
        hundredShownHere = false;
        /* A RESTORE IS A NEW LOAD, so the checkout reach starts again.
           This is the exact path back from /checkout on iOS Safari,
           which is the single most tap-sensitive arrival on the store:
           the customer lands on /cart with a thumb already moving. */
        loadAt = Date.now();
        warmed = false;
        kicked = false;
        kick();
      })
    );

    /* A hidden tab runs no rendering steps, so observers and timers
       there look exactly like broken code. Everything queued is
       re-checked the moment the tab comes back. */
    document.addEventListener(
      'visibilitychange',
      guard(function () {
        if (document.visibilityState !== 'visible') {
          stopFilms();
          return;
        }
        if (pending) queue(0);
        syncFilms();
        evaluate();
      })
    );

    /* Theme editor: the section can be re-rendered under us. */
    document.addEventListener(
      'shopify:section:load',
      guard(function (ev) {
        if (ev.target && ev.target.querySelector && ev.target.querySelector('[data-ryze-promo]')) {
          refs = null;
          resolve();
          /* THE ONE SEAM WHERE THE BUSY STATE MAY BE CLEARED, because
             it is the only one where the DOM is known fresh: Liquid
             just re-rendered every control, so none of them carries
             aria-disabled or .is-busy and there is nothing for a
             re-enable to duplicate. A module flag left true here would
             refuse every tap for the rest of the editor session with
             nothing on screen to explain it. */
          clearBusy();
        }
        watchBadge();
      })
    );

    document.addEventListener(
      'shopify:section:unload',
      guard(function (ev) {
        if (ev.target && ev.target.querySelector && ev.target.querySelector('[data-ryze-promo]')) {
          hide();
          refs = null;
        }
      })
    );
  }

  /* ─── The QA surface. Exactly four members ────────────────── */

  window.RyzePromo = {
    version: VERSION,

    evaluate: guard(function () {
      evaluate();
    }),

    state: guard(function () {
      var st = readState();
      return {
        version: VERSION,
        ready: !!refs,
        open: isOpen,
        message: refs ? refs.host.getAttribute('data-message') || null : null,
        view: refs ? refs.host.getAttribute('data-view') : 'message',
        /* Which of the menu's two lists the box is on, so a field
           test can tell the 50 ml picker from the 100 ml one without
           reading the DOM. Meaningless while view is 'message'. */
        menuSize: refs ? menuSize() : null,
        greetFocus: refs ? refs.host.getAttribute('data-greet-focus') : null,
        cart: lastCart
          ? { qty50: lastCart.qty50, has100: lastCart.has100 ? 1 : 0, empty: lastCart.itemCount === 0 }
          : null,
        quiets: {
          greet: num(st.q.greet),
          pair: num(st.q.pair),
          bundle: num(st.q.bundle),
          hundred: num(st.q.hundred)
        },
        quietLeft: {
          greet: quietLeft('greet'),
          pair: quietLeft('pair'),
          bundle: quietLeft('bundle'),
          hundred: quietLeft('hundred')
        },
        /* 1 = a real dismissal (survives a cart change, lives
           dismiss_minutes), 0 = a machine quiet. Reported because the
           two are indistinguishable from the timestamp alone and a
           field test needs to see which rule it is watching. */
        dismissed: {
          greet: st.k.greet === 1 ? 1 : 0,
          pair: st.k.pair === 1 ? 1 : 0,
          bundle: st.k.bundle === 1 ? 1 : 0,
          hundred: st.k.hundred === 1 ? 1 : 0
        },
        /* THE TIER B SURFACE RULES, as facts rather than as guesses
           from the URL: whether this page is a quiet room, how much
           of the checkout reach is left, and how long the courtesy
           hold still has to run. */
        tierB: {
          quietRoom: refs ? quietRoom() : false,
          armed: !!(refs && refs.host.classList.contains('is-armed')),
          reachLeft: onCartPage() ? Math.max(0, CART_REACH_MS - (Date.now() - loadAt)) : 0,
          touchHoldLeft: lastTouchAt ? Math.max(0, TOUCH_HOLD_MS - (Date.now() - lastTouchAt)) : 0
        },
        day: st.d,
        tab: { g: greetSeenHere() ? 1 : 0 },
        pill: {
          armed: pillArmed,
          showing: !!(refs && refs.pill && refs.pill.classList.contains('is-open'))
        },
        storage: storageOk ? 'local' : 'memory',
        blocked: blocked() ? uiBlocker() || (isOpen ? 'open' : presentJob ? 'presenting' : 'pill') : false
      };
    }),

    /* The owner's field-test switch and the QA entry point for every
       scenario. CLOSES FIRST: wiping the state under an open box used
       to leave the lock claimed, so the next showing found it busy
       and returned nothing. */
    reset: guard(function () {
      hide();
      cancelPresent();
      clearTimeout(showTimer);
      clearTimeout(pillTimer);
      clearTimeout(pillWaitTimer);
      clearTimeout(slowTimer);
      stopQueue();
      pending = null;

      /* EVERY LIVE FLAG, not only the ones in storage. Two survived
         and both fired later, into a scenario that had nothing to do
         with them: menuBusy refused every Add on the "reset"
         component until an old request settled, and cartDirty made
         the next X reload the cart page with nothing added since.
         clearBusy() takes the add token with it, so an add still in
         flight cannot write over what comes next. */
      clearBusy();
      cartDirty = false;

      if (refs && refs.pill) {
        refs.pill.classList.remove('is-open');
        refs.pill.classList.remove('is-leaving');
        if (refs.pillText) refs.pillText.textContent = '';
      }
      pillUntil = 0;
      pillArmed = false;

      mem = null;
      memTab = null;
      /* storageOk is set from what the store actually did, not
         assumed before asking it: assuming made state() report
         'local' on a device where storage throws, which is the
         inverse of the lie the flag exists to prevent. */
      try {
        localStorage.removeItem(STATE_KEY);
        storageOk = true;
      } catch (e) {
        storageOk = false;
      }
      try {
        sessionStorage.removeItem(TAB_KEY);
      } catch (e) {
        /* the mirror is already cleared */
      }

      /* THE PER-LOAD FLAGS GO BACK TO THEIR LOAD VALUES, the two Tier
         B ones included: a field test that calls reset() is asking for
         a clean page, and a stale loadAt would hand it a checkout
         reach that expired minutes ago. lastTouchAt is deliberately
         NOT cleared — the finger that just tapped the console or the
         QA button is real, and the courtesy hold is right to see it. */
      hundredShownHere = false;
      loadAt = Date.now();
      warmed = false;
      kicked = false;
      kick();
    })
  };

  /* ─── Bootstrap, guarded ─────────────────────────────────── */

  try {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', guard(init));
    else init();
  } catch (e) {
    panic();
  }
})();
